export default {
  message: {
    details: 'Détails',
    back: 'Retour',
    exportDataTitle: 'Télécharger les listes sous forme de fichier Excel',
    mobile_phone: 'Numéro de téléphone portable',
    sales_representative: 'Représentant commercial',
    commitment_letter_accept: "Lettre d'engagement acceptée",
    iban_number: 'Numéro IBAN',
    without_supplier: 'Sans fournisseur',
    price_in_euro: 'Prix de vente',
    is_default: 'défaut',
    attribute_option: "option d'attribut",
    image: 'Image',
    show_stats_user: 'Statistiques de la boutique – UTILISATEURS',
    shopUserStats: {
      pageTitle: 'Statistiques boutique – Utilisateurs',
      viewList: 'Voir les statistiques',
      perPage: 'Lignes par page',
      searchPlaceholder: 'Rechercher par e-mail, numéro client, société…',
      paginationSummary: '{from}–{to} sur {total} (page {page} / {lastPage})',
      loadError: 'Impossible de charger les statistiques utilisateurs boutique.',
      exporting: 'Export en cours…',
      exportDone: 'Export terminé ({rows} lignes).',
      exportFailed: 'Échec de l’export.',
      exportPanel: {
        title: 'Export Excel',
        refreshStatus: 'Actualiser le statut',
        lastExport: 'Dernier export',
        lastPoint: 'Dernier point',
        rowCount: 'Lignes',
        stateReadyFresh: 'Les données sont à jour. Vous pouvez télécharger l’export.',
        stateReadyStale:
          'L’import des points est plus récent que le dernier export. Téléchargez le fichier précédent ou attendez le prochain cycle (toutes les 15 min).',
        stateWaitingRefresh: 'Génération du nouveau fichier…',
        stateNoFile: 'Le fichier d’export n’est pas encore disponible.',
        firstFileEta: 'Premier fichier prévu vers {eta}.',
        downloadExcel: 'Télécharger Excel',
        formatLabel: 'Format',
        formatXlsx: 'XLSX (.xlsx)',
        formatXls: 'XLS (.xls)',
        downloadLastFile: 'Télécharger le dernier fichier',
        waitForUpdate: 'Attendre la mise à jour',
        refreshInProgress: 'Mise à jour en cours…',
        downloadSuccess: 'Fichier téléchargé.',
        downloadUpdatedSuccess: 'Fichier mis à jour téléchargé.',
        downloadRunning: 'Mise à jour en cours, réessayez dans un instant.',
        downloadNotReady: 'Fichier pas encore prêt. Prochaine tentative vers {eta}.',
        waitTimeout: 'Délai dépassé en attendant un nouvel export.',
        statusLoadFailed: 'Impossible de charger le statut d’export.',
        staleConfirmTitle: 'Télécharger un export plus ancien ?',
        staleConfirmBody: 'Le fichier date du {exportAt}, les points ont été mis à jour le {pointAt}. Continuer ?'
      }
    },
    is_manual_order: "Il s'agit d'une commande manuelle",
    supplier_id: 'ID du fournisseur',
    vendor_id: 'ID du fabricant',
    archive_at: 'Archive',
    exported_bridgestone: 'Exportations Bridgestone',
    exported_engelbert: 'ExportationsEngelbert Strauss',
    exported_prime: 'Exportations PremiumDirect',
    exported_other: "D'autres exportés",
    product_variant_id: 'ID de variante de produit',
    cancelled_at: 'Annulé à',
    shipped_at: "L'expédition a lieu le",
    product_id: 'Identifiant du produit',
    quantity: 'Foule',
    qty: 'Menzé',
    action_text: "Texte de l'URL",
    action_url: 'URL',
    token: 'UUID',
    marketing_option: 'Possibilité de commercialisation',
    parent_id: 'ID parent',
    parent_name: 'Nom du parent',
    approval_id: "ID d'approbation",
    wholesaler_id: 'Identifiant du grossiste',
    cart_id: 'Identifiant du panier',
    order_date: 'Date de commande',
    order_number: 'Numéro de commande',
    accept_date: "Date d'acceptation",
    wholesaler_dealer_id: 'Identifiant du grossiste',
    dealer_id: 'identifiant du revendeur',
    is_partial_delivery: 'Est-ce une livraison partielle',
    order_completed: 'Commande terminée',
    order_cancelled: 'commande annulée',
    date_delivery: 'date de livraison',
    published: 'Publier',
    properties: 'Caractéristiques',
    group: 'Nom de groupe',
    gka: 'GKA',
    publish_at: 'Publier',
    video: 'URL de la vidéo',
    training_id: 'ID de formation',
    correct: "C'est juste?",
    question_id: 'Numéro de question',
    body: 'Contenu',
    size: 'Taille du texte',
    platform: 'système opérateur',
    is_added: 'Boosters actifs',
    numberOfSetsOfSeasonalTiresBudget: 'stockage par an',
    distributionWinter: 'hiver',
    distributionSummer: 'été',
    overEighteenInch: 'Dont ≥ 18 pouces (en %)',
    tireSalesNumber: 'Ventes de pneus par an env.',
    distributionAll: 'Toutes saisies',
    budgetPremium: 'Prime',
    postal_code: 'Code Postal',
    legalForm: 'forme juridique',
    budgetMid: 'Milieu',
    budgetLow: 'Budget',
    group_id: 'Identifiant du groupe',
    website: 'site web',
    customer_number: 'Numéro de client',
    user_id: "ID de l'utilisateur",
    browser: 'navigateur Internet',
    ip: 'adresse IP',
    email_verified_at: 'E-mail confirmé à',
    last_login: 'Dernière connexion',
    deleted_at: 'supprimé le',
    is_active: "c'est actif?",
    old: 'Vieux',
    selectBooster: 'Sélectionnez le booster',
    activeBooster: 'Booster actif',
    activeBoosterText: "Voulez-vous activer un booster actif pour l'utilisateur ?",
    activeBoostersOne: 'Allez-vous activer ce booster pour chaque utilisateur ?',
    activeBoostersSalesDataWarning:
      'Veuillez vous assurer que les données de vente que vous allez booster sont les chiffres de vente définitifs et qu’elles ne seront pas modifiées à l’avenir. Dans le cas contraire, des écarts peuvent apparaître dans les calculs. Cette action est irréversible.',
    sum: 'total',
    boosterOnTop: 'Points Booster (supplémentaires)',
    relevantBoosterPoints: 'Points pertinents pour les boosters',
    totalBefore: 'Total de points avant',
    standardPoints: 'Points standards',
    standard: 'Standard',
    boosterPoints: 'Points de rappel',
    allPoints: 'Tous les points',
    pointsByUser: 'Points de téléchargement par utilisateur',
    pointsByGroup: 'Points de téléchargement par groupe',
    allKickbacks: 'Tous les kickbacks',
    kickbackByUser: 'Télécharger le kickback par utilisateur',
    kickbackByGroup: 'Télécharger le kickback par groupe',
    pointsImportFileInfo: "Dans le fichier, la colonne 1 doit être l'email et la colonne 2 les points.",
    pointsImportHeaderInfo:
      'La première ligne doit contenir les en-têtes : Email et Points. Les données doivent commencer à la deuxième ligne.',
    pointsImportValueInfo:
      'Les valeurs de points dans le fichier doivent être positives ou négatives. Utilisez des valeurs positives pour ajouter des points et des valeurs négatives pour en retirer.',
    pointsImportTitle: 'Import des points depuis un fichier Excel',
    pointsImportFailed: "Échec de l'import",
    pointsImportSummaryTitle: 'Résumé de l’import',
    pointsImportProcessed: 'Traités',
    pointsImportInvalidFile: 'Seuls les fichiers Excel (.xlsx, .xls) sont autorisés.',
    pointsImportPreviewLoading: "Préparation de l'aperçu du fichier...",
    pointsImportPreviewCount: 'Affichage de {shown} lignes sur {count} du fichier.',
    pointsImportPreviewEmpty: 'Le fichier sélectionné ne contient aucune ligne à importer.',
    pointsImportPreviewError: 'Impossible de lire le fichier Excel sélectionné.',
    pointsImportDateInfo:
      'La date sélectionnée sera utilisée comme date de création des points sur le compte utilisateur. Ces points peuvent également concerner des périodes passées.',
    loginAs: "Connectez-vous en tant qu'utilisateur",
    positionX: 'Poste X',
    positionY: 'Poste y',
    textSize: 'Taille du texte',
    text: 'Texte',
    publish: 'Publier',
    certificate: 'certificat',
    certificatePdf: {
      title: 'CERTIFICAT',
      tookPartInCourse: 'a participé au cours :',
      courseDetails: 'Détails du cours'
    },
    event: 'événement',
    remove_cs_number: 'Êtes-vous sûr de vouloir supprimer le numéro de client {customerNumber} ({wholesaler}) ?',
    keep_previous_year_points: 'Conserver les points des années précédentes après la suppression du numéro client',
    keep_previous_year_points_warning:
      'If you select this option, deleting the customer number will remove only points from the current year. Points from previous years will remain, so older balances and reports may still include data linked to this customer number. Select this only if you want to keep past years unchanged.',
    remove_order: 'Êtes-vous sûr de vouloir supprimer la commande ?',
    is_internal: 'Est-ce un utilisateur interne ?',
    selectAddressBtn: "choisir l'adresse",
    currentBasket: 'Panier actuel',
    loginEmail: 'Inscription',
    tenantEmailType: "Type d'e-mail",
    tenantEmailAddNew: 'Ajouter un nouvel e-mail',
    tenantEmailTypeFinancial: 'Pour les informations financières (p.ex. détail des bonus)',
    tenantEmailTypeMarketing: 'Pour les communications marketing Bridgestone Plus (p.ex. promotions/newsletters)',
    open_new_tab: 'Ouvrir dans un nouvel onglet?',
    newTabLabel: 'Nouvel onglet',
    file: 'Déposer',
    company_name: 'entreprise',
    partner_name: 'Personne de contact',
    dealer: 'Marchand',
    boosterImport: {
      label: 'Fichier CSV/XLSX/XLS.',
      name: "Nom de l'importation"
    },
    created_at: 'Créé sur',
    done_by: 'Effectué par',
    authors: 'Effectué par',
    changes: 'Modifications',
    modified_user: 'Utilisateur concerné',
    modified_users: 'Utilisateurs concernés',
    full_text_search: 'Recherche en texte intégral',
    logs: 'Journaux',
    activity: 'activité',
    booster_create: 'Créer des boosters',
    booster_brands: 'Marques',
    booster_motor: 'Moto',
    booster_message_title: 'Titre du message',
    booster_delete_points: 'Supprimer les points',
    booster_delete_points_confirm: 'Êtes-vous sûr de vouloir supprimer ces points booster ? Cette action est irréversible.',
    booster_wholesaler: 'Grossiste',
    booster_products: 'Noms des produits',
    booster_customers: 'Numéros de clients',
    booster_saison: 'Saison',
    booster_name: 'Nom de famille',
    booster_factor: 'facteur',
    booster_from: "temps d'exécution de",
    booster_to: "Durée jusqu'à",
    boosterList: {
      seasons: 'Saisons',
      usersAmount: "Nombre d'utilisateurs",
      factor: 'Facteur',
      calculateBoosters: 'Calculer les boosters',
      calculateBoostersConfirmTitle: 'Calculer les boosters ?',
      calculateBoostersConfirm:
        'Cela lancera le calcul des points booster pour les utilisateurs correspondants selon cette configuration. Le processus peut prendre un certain temps. Les résultats apparaîtront dans l’aperçu des boosters, où vous pourrez les vérifier et les accepter ou supprimer les points calculés. Une fois le calcul terminé, la modification de ce booster peut ne plus être possible. Voulez-vous continuer ?',
      showAll: 'Tout afficher (+{count})',
      showLess: 'Afficher moins'
    },
    booster_tires: 'Dimensions des pneus',
    booster_ipcs: 'CIP',
    boosterIpcsImport: {
      button: 'Téléverser les IPCs depuis Excel',
      hint: 'Colonne A, fichier .xlsx/.xls',
      emptySheet: 'Feuille vide.',
      emptyColumn: 'Aucune donnée dans la colonne A.',
      spacesError: 'IPCs invalides (contiennent des espaces) : {items}',
      invalidFormatError: 'Format IPC invalide (chiffres uniquement) : {items}',
      requestValidationError: 'Erreur de validation de la requête.',
      unknownError: 'IPCs inconnus : {items}',
      success: 'IPCs importés : {count}',
      readError: "Impossible de lire le fichier d'IPCs."
    },
    select: "Choisissez s'il vous plaît",
    booking: 'billetterie',
    credit: 'Crédit',
    deduction: 'Déduction',
    preview: 'Aperçu',
    subject: 'Concernant',
    customerNumber: 'Numéro de client',
    search: 'Chercher',
    customer_nr_name: 'Numéro/nom du client',
    selectAll: 'tout sélectionner',
    deselectAll: 'Tout désélectionner',
    generateReport: {
      selectAll: 'Tout sélectionner',
      reset: 'Réinitialiser',
      loadingInfo: 'Génération du rapport en cours, veuillez patienter...',
      generate: 'Générer',
      validation: {
        distributorRequired: 'Veuillez sélectionner au moins un distributeur.'
      },
      personal_data: {
        title: 'Données personnelles',
        email: 'E-mail',
        salutation: 'Salutation',
        first_name: 'Prénom',
        last_name: 'Nom',
        job_position: 'Fonction'
      },
      shipping_address: {
        title: 'Adresse de livraison',
        company: 'Entreprise',
        street: 'Rue',
        postal_code: 'Code postal',
        mobile_phone: 'Téléphone mobile',
        iban_number: 'IBAN',
        vat: 'TVA',
        city: 'Ville'
      },
      operating_data: {
        title: "Données d'activité",
        customer_number: 'Numéro client',
        group: 'Groupe',
        first_registration: 'Première inscription',
        last_login: 'Dernière connexion',
        tires_per_year: 'Ventes de pneus par an',
        over_18_inch: 'Plus de 18 pouces',
        premium: 'Premium',
        middle: 'Moyen',
        summer: 'Été',
        winter: 'Hiver',
        all_season: 'Toutes saisons',
        major: 'Marque'
      },
      calculated_data: {
        title: 'Données calculées',
        tireAmount: 'Quantité de pneus',
        points: 'Points',
        bonus: 'Bonus'
      },
      sales_structure: {
        title: 'Structure commerciale',
        distributor: {
          title: 'Distributeur'
        },
        sales_representative: {
          title: 'Représentant commercial'
        },
        wholesaler: {
          title: 'Grossiste'
        },
        dealer: {
          title: 'Concessionnaire'
        }
      },
      meta: {
        title: 'Filtres',
        brand: {
          title: 'Marque',
          BS: 'BS',
          FS: 'FS'
        },
        year: {
          title: 'Année'
        },
        calendarMonth: {
          title: 'Mois',
          january: 'Janvier',
          february: 'Février',
          march: 'Mars',
          april: 'Avril',
          may: 'Mai',
          june: 'Juin',
          july: 'Juillet',
          august: 'Août',
          september: 'Septembre',
          october: 'Octobre',
          november: 'Novembre',
          december: 'Décembre'
        }
      }
    },
    import: 'Importer',
    rows: 'Lignes',
    message: 'Message',
    articleNumber: "numéro d'article",
    inform_user: 'informer les clients',
    leaveComment: 'Laissez un commentaire ici',
    user_new: 'Nouvel utilisateur',
    postalcode: 'Code postal',
    city: 'Emplacement',
    residence: 'Est-ce que la résidence',
    country: 'pays',
    street: 'Rue et numéro de maison',
    salutation: 'Salutation',
    suffix: "Supplément d'adresse",
    emailVerified: 'E-mail vérifié le',
    registerAt: 'Inscrit le',
    phone: 'téléphone',
    optinAt: 'Inscrivez-vous sur',
    fax: 'Fax',
    date: 'Date',
    optinToken: "Jeton d'inscription",
    language: 'Langue',
    company: 'entreprise',
    forename: 'Prénom',
    lastname: 'Nom de famille',
    title: 'titre',
    subtitle: 'Sous-titre',
    remove: 'Supprimer',
    actions: 'Actions',
    userData: "Données d'utilisateur",
    clientType: 'Type de client',
    carDealer: 'Concessionnaire automobile',
    tyreDealer: 'Revendeur de pneus',
    teamLkw: 'Team PL',
    teamEmOtr: 'Team EM/OTR',
    teamFarmTractor: 'Team tracteur agricole',
    teamBandag: 'Team Bandag',
    chooseDots: 'Choisir..',
    both: 'Les deux',
    contact_service: {
      is_main: 'Contact principal ?',
      direct: 'Direct',
      indirect: 'Indirect'
    },
    fileChoose: 'Choisir un fichier',
    fileNoSelected: 'Aucun fichier sélectionné',
    loadingFile: 'Chargement du fichier...',
    only_points_payment: 'Paiement uniquement en points',
    column: 'Colonne',
    csvOnly: 'Seuls les fichiers CSV sont autorisés.',
    milestoneUsers: {
      csvImportTitle: 'Import CSV',
      csvFormatHint: 'Format CSV: <code>email,milestone</code> (en-tete optionnel)',
      importErrorsTitle: "Erreurs d'import",
      errorLine: 'Ligne {line}: {message}',
      importFinished: 'Import CSV termine.'
    },
    kickbackPayoutReady: 'Formulaire prêt à être envoyé. Fichier sélectionné :',
    kickbackPayoutCsvInstruction:
      'Le fichier CSV doit contenir deux colonnes : la première avec l’e-mail, la deuxième avec la valeur du bonus en EUR.',
    kickbackPayoutCsvHeaderInvalid:
      'En-tête CSV invalide. La première colonne doit être Email, la deuxième au format Bonus <nombre> (ex. Bonus 25).',
    kickbackPayoutCsvTwoColumnsOnly: 'Le CSV doit contenir exactement deux colonnes : Email et nombre.',
    kickbackPayoutCsvEmailNumberInvalid:
      'Données CSV invalides. La première colonne doit être une adresse e-mail, la deuxième un nombre.',
    kickbackPayoutCsvBonus: 'Bonus CSV',
    kickbackPayoutKickBackFeeSum: 'Somme kickback',
    kickbackPayoutYear: 'Annee',
    kickbackPayoutMissingEmails: 'E-mails manquants :',
    kickbackPayoutCsvFile: 'CSV',
    kickbackPayoutCsvContent: 'Contenu CSV',
    kickbackPayoutAllTranslationsRaw: 'Toutes les traductions (raw)',
    multiplicator: {
      goals: {
        loyal: 'Fidele',
        bronze: 'Bronze',
        silver: 'Argent',
        gold: 'Or',
        platinum: 'Platine'
      }
    },
    importSchemaNotLoaded: "Le schéma d'import n'est pas chargé.",
    csvHeaderEmpty: 'L’en-tête CSV est vide.',
    csvHeaderMismatch: 'En-tête CSV non conforme à la colonne {index} : attendu "{expected}", obtenu "{actual}".',
    csvHeaderMismatchTitle: 'En-tête CSV non conforme',
    csvColumnCountMismatchTitle: 'Nombre de colonnes CSV incorrect',
    csvColumnCountMismatch: 'Ligne {row} : {expected} colonnes attendues, {actual} obtenues.',
    csvHeaderColumnCountMismatch: 'Ligne d’en-tête : {expected} colonnes attendues, {actual} obtenues.',
    step: 'Étape',
    profile: 'Profil',
    addresses: 'Adresses',
    address: 'Adresse',
    notAvailable: 'Actuellement non disponible pour le moment',
    disabled: 'Désactivé',
    archived: 'Archivé',
    visible_not_allowed_to_buy: 'Visible, achat non autorisé',
    isDefault: 'Défaut',
    data: 'Données',
    importText: 'Veuillez sélectionner un fichier à importer:',
    importSchemaInfo: "Le fichier CSV doit contenir les champs suivants dans l'ordre exact indiqué ci-dessous.",
    importConfirm: "Consultez l'aperçu d'import ci-dessous. Voulez-vous continuer l'importation ?",
    importWholesalerHint: 'Facultatif. Si sélectionné, les numéros clients du CSV seront attribués à ce grossiste.',
    importDownloadTemplate: 'Télécharger le modèle CSV vide',
    importModalTitle: 'Importer des utilisateurs depuis un CSV',
    importStepSetup: 'Configuration',
    importStepPreview: 'Aperçu',
    importStepResult: 'Résultat',
    importStepHelper: 'Téléchargez le modèle, complétez vos données, puis importez le fichier CSV.',
    importContextTitle: 'Paramètres d’import',
    importRowsInFile: '{count} lignes dans le fichier',
    importValidating: 'Validation du fichier...',
    importPreviewLoading: 'Chargement de l’aperçu...',
    importSubmitting: 'Importation des utilisateurs...',
    importStatsSuccess: 'Succès',
    importStatsError: 'Erreurs',
    importStatsInfo: 'Info',
    importStatsOther: 'Autres',
    importShowSchema: 'Afficher le schéma des colonnes',
    importHideSchema: 'Masquer le schéma des colonnes',
    importPreviewChangesCount: '{count} modifications de champs',
    importDropzoneTitle: 'Déposez le fichier CSV ici',
    importDropzoneHint: 'ou cliquez pour choisir un fichier',
    importSelectClientTypeForPreview:
      'Le fichier semble valide ({count} lignes). Sélectionnez le type de client pour charger l’aperçu.',
    importFileValid: 'Fichier validé avec succès ({count} lignes).',
    importLoadPreview: 'Charger l’aperçu',
    importPreviewFilterErrors: 'Erreurs',
    importPreviewRowError: 'Erreur',
    importPreviewFailed: "Échec du chargement de l'aperçu d'import.",
    importPreviewSummary: 'Résumé',
    importPreviewTotalRows: 'Lignes totales',
    importPreviewNewUsers: 'Nouveaux utilisateurs',
    importPreviewUpdatedUsers: 'Utilisateurs mis à jour',
    importPreviewSkippedRows: 'Lignes ignorées',
    importPreviewErrors: 'Erreurs',
    importPreviewNewCustomerGroups: 'Nouveaux groupes clients',
    importPreviewNewStaffUsers: 'Nouveaux commerciaux',
    importPreviewAction: 'Action',
    importPreviewIncoming: 'Entrant',
    importPreviewCreates: 'Créations',
    importPreviewUpdates: 'Mises à jour',
    importPreviewFieldChanges: 'Modifications de champs',
    importPreviewFieldColumn: 'Champ',
    importPreviewCurrentValue: 'Actuel',
    importPreviewFromFile: 'Du fichier',
    importPreviewAfterImport: 'Après import',
    importPreviewNewValue: 'Nouveau',
    importPreviewWillChange: 'Sera modifié',
    importPreviewDiffersInFile: 'Diffère dans le fichier',
    importPreviewOnlyWithChanges: 'Uniquement les lignes avec modifications',
    importPreviewFilterAll: 'Toutes les lignes',
    importPreviewShowDetails: 'Détails',
    importPreviewBackToList: 'Retour à la liste',
    importPreviewHideDetails: 'Masquer les détails',
    importPreviewNoFilterResults: 'Aucune ligne ne correspond aux filtres sélectionnés.',
    importPreviewRowDetails: 'Détails de la ligne',
    importPreviewPlannedChanges: 'Modifications prévues',
    importPreviewExistingData: 'Données actuelles dans le système',
    importPreviewFullComparison: 'Comparaison complète',
    importPreviewNoExistingData: 'Aucune donnée existante (nouvel utilisateur).',
    importPreviewNoFieldDetails: 'Aucun détail de champ disponible pour cette ligne.',
    importPreviewCustomerGroups: 'Groupes clients',
    importPreviewExistingCustomerGroups: 'Groupes existants',
    importPreviewActionCreate: 'Créer',
    importPreviewActionUpdate: 'Mettre à jour',
    importPreviewActionUnchanged: 'Inchangé',
    importPreviewActionSkip: 'Ignorer',
    importPreviewNoCreates: 'Rien de nouveau ne sera créé',
    importPreviewNoUpdates: 'Aucun champ ne sera mis à jour',
    importPreviewNoRowDetails: 'Le résumé est disponible, mais les détails des lignes n’ont pas pu être chargés.',
    importPreviewDuplicateInFile: 'Doublon dans le fichier',
    importSuccess: "L'importation a été réalisée avec succès",
    importErrors: "Erreurs d'importation",
    fileErrors: 'Erreurs de fichier',
    normalizerErrors: 'Erreurs de normalisation',
    row: 'Ligne',
    rowData: 'Données de ligne',
    validationErrors: 'Erreurs de validation',
    importerErrors: "Erreurs d'importateur",
    upload: 'Télécharger',
    users: 'utilisateur',
    permission: 'Droite',
    save: 'Sauvegarder',
    saving: 'Enregistrement...',
    downloadOrderStats: 'Télécharger les statistiques',
    downloadProductStats: 'Télécharger les statistiques des produits',
    category: 'catégorie',
    order: 'Commande',
    permissions: 'droite',
    edit_permissions_title: 'Modifier les autorisations',
    options: 'Possibilités',
    attributes: 'Les attributs',
    add_attribute: 'Ajouter des attributs',
    login: 'se connecter',
    logout: 'Se déconnecter',
    email: 'E-Mail',
    username: 'utilisateur',
    filter: 'Filtre',
    name: 'Nom de famille',
    points: 'Points',
    sku: 'UGS',
    count: 'Nombre',
    action: 'Action',
    active: 'Actif',
    activeLabel: 'Actif',
    type: 'Taper',
    status: 'condition',
    main: 'Produit principal',
    vendor: 'Fabricant',
    supplier: 'fournisseur',
    variant: 'Variante de produit',
    description: 'Description',
    short_description: 'Brève description',
    upload_text: "Téléchargement d'images de produits",
    product_new: 'Nouveau produit unique',
    product_new_variants: 'Nouvelle variante de produit',
    training_new: 'Nouvelle formation',
    btraining_new: 'Nouvelle formation BS',
    images: 'Des photos',
    roles: 'rouler',
    search_products: 'Recherche de produit',
    search_orders: 'Ordres de Recherche',
    search_type: 'Type de recherche',
    hunter_new: 'Nouveau chasseur',
    first_name: 'Prénom',
    last_name: 'Nom de famille',
    urssaf_address: 'Adresse personnelle requise uniquement pour l’URSSAF',
    social_security_number: 'Numéro de sécurité sociale',
    place_of_birth: 'Lieu de naissance',
    date_of_birth: 'Date de naissance',
    copy: 'Copie',
    add_empty_variant: 'Ajouter une variante vide',
    points_exporter_users_with_available_points: 'Utilisateurs avec points disponibles',
    points_exporter_unlocked_points: 'Export des utilisateurs avec points débloqués',
    points_exporter_date_label: 'Date',
    start_date: 'Date de début',
    end_date: 'Date de fin',
    points_exporter_download_button: 'Télécharger Excel',
    menu: {
      customerGroup: {
        new: 'Nouveau groupe de clients',
        list: 'Liste des groupes de clients'
      },
      shopLimits: 'Shop limits',
      default_banners: 'Bannières par défaut',
      import_adex: 'importation adex',
      adex: 'Adex',
      logs: 'journaux',
      activities: 'activités',
      booster_setup: 'Configurer des boosters',
      booster_list: 'Liste',
      customer: 'Clients',
      'users-roles': 'Gestion des utilisateurs',
      roles: 'rouler',
      booster: 'amplificatrice',
      cheques: 'Chèques et déductions',
      points: 'Gestion des points',
      users: 'utilisateur',
      users_list: "Liste d'utilisateur",
      milestone_users: 'Utilisateurs milestone',
      shop_user_stats_list: 'Statistiques utilisateurs boutique',
      user_new: 'Nouvel utilisateur',
      users_deleted: 'Utilisateurs supprimés',
      perms: 'droite',
      'products-categories': 'Boutique de récompenses',
      categories: 'Catégories',
      categories_list: 'Liste des catégories',
      category_new: 'Nouvelle catégorie',
      orders: 'Ordres',
      products: 'Des produits',
      products_list: 'Liste de produits',
      product_new: 'Nouveau produit unique',
      product_new_variants: 'Nouvelle variante de produit',
      attributes: 'Les attributs',
      attributes_list: 'Liste des attributs',
      attribute_new: 'Nouveaux attributs',
      options: 'Possibilités',
      options_list: 'Liste des options',
      options_new: 'Nouvelle option',
      vendors: 'Fabricant',
      vendors_list: 'Liste des fabricants',
      vendor_new: 'Nouveau fabricant',
      suppliers: 'Fournisseurs',
      suppliers_list: 'Liste des fournisseurs',
      supplier_new: 'Nouveau fournisseur',
      sliders: 'Curseur principal du teaser',
      sliders_list: 'Liste',
      slider_new: 'Nouveau curseur de teaser principal',
      featured: 'Produits teasers',
      commands: 'Commandes',
      command_ipc: 'CIB',
      command_users: 'Importer des utilisateurs',
      'trainings-schulungen': 'Formation et éducation',
      trainings: 'La formation en ligne',
      trainings_list: 'Liste',
      training_new: 'Ajouter un nouveau',
      btrainings: 'Formation BS',
      btrainings_list: 'Liste',
      btraining_new: 'Ajouter un nouveau',
      management: 'Gestion de contenu',
      textpages: 'Pages de texte',
      textpages_list: 'Liste',
      text_page_new: 'Ajouter un nouveau',
      marketing_consents: 'Consentements marketing',
      marketing_consents_list: 'Liste des consentements',
      marketing_consents_edit: 'Modifier le consentement',
      settings: 'Responsable des actualités',
      messages: 'Créer des messages',
      messages_list: 'Liste',
      messages_new: 'Ajouter un nouveau',
      threads: 'Configurer des e-mails automatiques',
      requests: 'Demandes des utilisateurs',
      product_trainings_request: 'La formation en ligne',
      bridgestone_courses_request: 'Formation BS',
      external_trainings_request: 'Formation extérieure',
      hunter_request: 'chasseur',
      investments_request: "Soutien à l'investissement",
      news_feed: 'nouvelles',
      news_feed_list: 'Liste',
      news_feed_new: 'Ajouter un nouveau',
      salespromotions: 'Promotion de ventes',
      promotions: 'Promotions',
      promotions_list: 'Liste',
      promotions_new: 'Nouveau',
      imported_products: 'Produits importés',
      ipcs_list: 'Liste IPC',
      hunter_list: 'Liste',
      hunters: 'Chasseur',
      hunter_new: 'Nouveau chasseur',
      groups: 'groupes',
      groups_list: 'Liste de groupe',
      parent_attributes: 'Attributs parents',
      group_new: 'Nouveau groupe',
      history: 'Historique de connexion',
      history_list: 'Historique de connexion',
      prices: 'Nouveau Pricat',
      prices_list: 'Liste',
      price_new: 'Nouveau Pricat',
      price_categories: 'Listes de prix',
      price_categories_list: 'Liste',
      price_categories_new: 'Nouvelles listes de prix',
      inactive_users: 'Nouvelles inscriptions<br/>libération',
      customer_numbers_to_approve: 'Nouvelles inscriptions<br/>sans numéro',
      complaints: 'Formulaire de réclamation',
      orders_list: 'Liste',
      orders_new: 'Nouvelles commandes',
      points_list: 'Liste des points',
      kickback_list: 'Frais de commission',
      kickback_payout: 'Paiement de commission',
      booster_preview: 'Aperçu',
      frontend_menu: 'Menu frontal',
      frontend_menu_list: 'Liste',
      frontend_menu_new: 'Nouveau',
      'customer-groups': 'Groupes de clients',
      'customer-groups-list': 'Liste des groupes de clients',
      'customer-groups-new': 'Nouveau groupe de clients',
      'customer-groups-edit': 'Modifier le groupe de clients',
      customer_group_new: 'Nouveau groupe de clients',
      mediapages: 'Forfaits médias',
      mediapages_list: 'Liste',
      media_page_new: 'Nouveau',
      uberall_request: 'Uberall',
      history_hour: "Horaires d'inscription",
      wholesaler_management: 'Gestion des grossistes',
      in_active_cs_nr: 'Numéros désactivés',
      mediapages_file_list: 'Liste de fichiers',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'New',
      brochure_prices_list: 'Liste',
      brochure_prices: 'Brochures produits & listes de prix',
      brochure_prices_new: 'Nouveau',
      brochure_file_list: 'Liste',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'List',
      main_box: 'Edit',
      main_boxes_new: 'New',
      'hello-customer-survey': 'Enquête clients Hello',
      apps: 'Applications',
      apps_list: 'Liste des applications',
      dealer_apps: 'Applications revendeur',
      about: 'Page À propos',
      about_list: 'Liste',
      about_new: 'Nouveau',
      about_edit: 'Modifier',
      contact_service: 'Service de contact',
      contact_service_list: 'Liste',
      contact_service_new: 'Nouveau',
      contact_service_edit: 'Modifier',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export',
      customer_numbers_assistant: 'Assistant de numéros client'
    },
    breadcrumb: {
      shopLimits: 'Shop limits',
      customer_numbers_assistant: 'Assistant de numéros client',
      in_active_cs_nr: 'Numéros désactivés',
      default_banners: 'Bannières par défaut',
      import_adex: 'Importation Adex',
      adex: 'Adex',
      activities: 'activités',
      booster_setup: 'Configurer des boosters',
      booster_list: 'Liste',
      customer: 'clients',
      booster: 'Amplificateur',
      booster_edit: 'Modifier',
      cheques: 'Chèques et déductions',
      user_edit: "Modifier l'utilisateur",
      users: 'utilisateur',
      user: 'utilisateur',
      vendors: 'Fabricant',
      vendor_new: 'Nouveau fabricant',
      suppliers: 'Fournisseurs',
      supplier_new: 'nouveau fournisseur',
      home: 'Maison',
      perms: 'droite',
      roles: 'rouler',
      roles_list: 'Liste',
      dashboard: 'Tableau de bord',
      orders: 'Ordres',
      orders_edit: 'Modifiez votre commande',
      orders_view: 'Commande',
      orders_list: 'Liste',
      salespromotions: 'Promotion de ventes',
      promotions: 'Promotions',
      promotions_list: 'Liste',
      promotions_new: 'Nouveau',
      promotions_edit: 'Modifier',
      salespromotions_list: 'Liste',
      salespromotions_view: 'voir',
      categories: 'Catégories',
      categories_list: 'Liste',
      role: 'rôle',
      category: 'catégorie',
      marketing_consents: 'Consentements marketing',
      marketing_consents_list: 'Liste des consentements',
      marketing_consents_edit: 'Modifier le consentement',
      products: 'Des produits',
      products_list: 'Liste',
      product: 'produit',
      product_category: 'Produits de la catégorie',
      product_new: 'Nouveau produit unique',
      product_new_variants: 'Nouvelle variante de produit',
      product_variants: 'Produit variante',
      attributes: 'Produit variante',
      attributes_list: 'Liste',
      attribute: 'Attribut',
      category_new: 'Nouvelle catégorie',
      attribute_edit: "Modifier l'attribut",
      options_new: 'Nouvelle option',
      options: 'Possibilités',
      options_list: 'Liste',
      options_edit: "Modifier l'option",
      userEdit: "Modifier l'utilisateur",
      users_list: 'Liste',
      milestone_users: 'Utilisateurs milestone',
      shop_user_stats_list: 'Statistiques utilisateurs boutique',
      users_deleted: 'Utilisateurs supprimés',
      vendor_edit: 'Modifier le fabricant',
      vendors_list: 'Liste',
      supplier_edit: 'Modifier le fournisseur',
      suppliers_list: 'Liste des fournisseurs',
      user_new: 'Nouvel utilisateur',
      trainings: 'Entraînement',
      trainings_list: 'Liste',
      btrainings: 'La formation en ligne',
      btrainings_list: 'Liste',
      btraining: 'La formation en ligne',
      training_new: 'Nouvelle formation',
      btraining_new: 'Nouvelle formation BS',
      training_edit: 'Modifier la formation',
      training: 'entraînement',
      command_ipc: 'CIB',
      sliders: 'Curseur principal du teaser',
      sliders_list: 'Liste',
      slider_new: 'Nouveau curseur de teaser principal',
      slider: 'Modifier le curseur du teaser principal',
      command_users: 'Importer des utilisateurs',
      textpages: 'Pages de texte',
      text_page_new: 'Nouvelle page de texte',
      textpage: 'Pages de texte',
      textpages_list: 'Liste',
      messages: 'Nouvelles',
      messages_list: 'Liste',
      messages_new: 'Nouveau message',
      messages_edit: 'modifier le message',
      threads: 'Concernant',
      featured: 'Produits teasers',
      attribute_new: 'Nouvel attribut',
      product_trainings_request: 'Demandes de formation en ligne',
      bridgestone_courses_request: 'Demandes de formation Bridgestone',
      external_trainings_request: 'Demandes de formations externes',
      hunter_request: 'Chasseur',
      investments_request: "Soutien à l'investissement",
      news_feed: 'nouvelles',
      news_feed_list: 'Liste',
      news_feed_new: "Nouveau fil d'actualité",
      news_feed_edit: "Modifier le fil d'actualité",
      news_feed_slider: 'Nouveau curseur de fil d’actualité',
      content: 'Contenu',
      imported_products: 'Produits importés',
      ipcs_list: 'Liste IPC',
      hunter_list: 'Liste',
      hunters: 'Chasseur',
      hunter_new: 'Nouveau chasseur',
      hunter_edit: 'Modifier le chasseur',
      groups: 'groupes',
      groups_list: 'Liste de groupe',
      parent_attributes: 'Attributs parents',
      group_new: 'Nouveau groupe',
      group_edit: 'Groupe Modifier',
      history: 'Historique de connexion',
      history_list: 'Historique de connexion',
      history_view: 'Historique de connexion des utilisateurs',
      prices: 'Pricat',
      prices_list: 'Liste',
      price_new: 'nouveau Pricat',
      price: 'Pricat modifier',
      price_categories: 'Liste de prix',
      price_categories_list: 'Liste',
      price_categories_new: 'Nouvelles listes de prix',
      price_category: 'Liste de prix',
      inactive_users: 'Publier les nouvelles inscriptions',
      inactive_users_list: 'Liste',
      customer_numbers_to_approve: 'Nouvelles inscriptions sans numéro',
      complaints: 'Formulaire de réclamation',
      complaints_list: 'Liste',
      complaints_view: 'Plainte',
      orders_new: 'Nouvelles commandes',
      points_list: 'Liste des points',
      kickback_list: 'Frais de commission',
      kickback_payout: 'Paiement de commission',
      booster_preview: 'Aperçu',
      frontend_menu: 'Menu frontal',
      frontend_menu_list: 'Liste',
      frontend_menu_new: 'Nouveau',
      'customer-groups': 'Groupes de clients',
      'customer-groups-list': 'Liste des groupes de clients',
      'customer-groups-new': 'Nouveau groupe de clients',
      mediapages: 'Forfaits médias',
      mediapages_list: 'Liste',
      media_page_new: 'Nouveau',
      mediapage: 'Modifier',
      uberall_request: 'Partout',
      history_hour: "Horaires d'inscription",
      wholesaler_management: 'Gestion des grossistes',
      mediapages_file_list: 'Liste de fichiers',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'New',
      brochure_prices_list: 'Liste',
      brochure_file_list: 'Liste',
      brochure_prices: 'Brochures produits & listes de prix',
      brochure_prices_new: 'Nouveau',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'List',
      main_box: 'Edit',
      main_boxes_new: 'New',
      'hello-customer-survey': 'Enquête clients Hello',
      apps_list: 'Liste des applications',
      app_new: 'Nouveau',
      app: 'Modifier',
      about: 'Page À propos',
      about_list: 'Liste',
      about_new: 'Nouveau',
      about_edit: 'Modifier',
      contact_service: 'Service de contact',
      contact_service_list: 'Liste',
      contact_service_new: 'Nouveau',
      contact_service_edit: 'Modifier',
      contact_service_description_list: 'Liste des descriptions du service de contact',
      contact_service_description_edit: 'Modifier la description du service de contact',
      contact_service_description_new: 'Nouvelle description du service de contact',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export'
    },
    orders: {
      view: 'Commande',
      new: 'nouvel ordre',
      list: 'Ordres',
      edit: 'Modifiez votre commande',
      number: 'Numéro de commande',
      date: 'Date de commande',
      state: 'statut de la commande',
      labels: {
        company: 'Entreprise',
        name: 'Nom',
        street: 'Rue',
        postalCodeCity: 'Code postal / Ville',
        userPhone: 'Téléphone utilisateur',
        userEmail: 'E-mail utilisateur',
        orderPhone: 'Téléphone de la commande'
      },
      status: {
        created: 'Créé',
        confirm_order: 'confirmer la commande',
        ready_for_shipment: "Prêt pour l'expédition",
        rejected: 'Rejeté',
        processed: 'Traité',
        shipped: 'Envoyé',
        returned: 'Revenu',
        finished: 'Prêt',
        deleted: 'Supprimé'
      },
      cartQuantityIncreased: 'La quantité du produit dans le panier a été augmentée.',
      cartQuantityDecreased: 'La quantité du produit dans le panier a été diminuée.',
      confirmIncreaseItem: 'Voulez-vous vraiment augmenter la quantité de ce produit dans la commande ?',
      confirmDecreaseItem: 'Voulez-vous vraiment diminuer la quantité de ce produit dans la commande ?',
      confirmDeleteItem: 'Voulez-vous vraiment retirer ce produit de la commande ?',
      deletedInfo: 'Cette commande a été supprimée le {date}',
      activityLogs: 'Historique des modifications',
      quantityChanged: 'Quantité : {from} → {to}',
      itemRemoved: 'Non livrable / retiré'
    },
    salespromotions: {
      view: "promotion d'achat",
      list: 'Promotions des ventes',
      premium: 'CONDUIRE NOTRE MEILLEUR',
      guarantee: 'PROTECTION DES PNEUS',
      bonusCampaign: 'COUP DE PNEUS',
      advantage: 'AVANTAGE PROMOTION'
    },
    countries: {
      ad: 'Andorre',
      ae: 'Émirats arabes unis',
      af: 'Afghanistan',
      ag: 'Antigua-et-Barbuda',
      ai: 'Anguilla',
      al: 'Albanie',
      am: 'Arménie',
      ao: 'Angola',
      aq: 'Antarctique',
      ar: 'Argentine',
      as: 'Samoa américaines',
      at: 'Autriche',
      au: 'Australie',
      aw: 'Aruba',
      ax: 'Îles Åland',
      az: 'Azerbaïdjan',
      ba: 'Bosnie-Herzégovine',
      bb: 'Barbade',
      bd: 'Bangladesh',
      be: 'Belgique',
      bf: 'Burkina Faso',
      bg: 'Bulgarie',
      bh: 'Bahreïn',
      bi: 'Burundi',
      bj: 'Bénin',
      bl: 'Saint-Barthélemy',
      bm: 'Bermudes',
      bn: 'Brunei',
      bo: 'Bolivie',
      bq: 'Pays-Bas caribéens',
      br: 'Brésil',
      bs: 'Bahamas',
      bt: 'Bhoutan',
      bv: 'Île Bouvet',
      bw: 'Botswana',
      by: 'Biélorussie',
      bz: 'Belize',
      ca: 'Canada',
      cc: 'Îles Cocos',
      cd: 'Congo-Kinshasa',
      cf: 'République centrafricaine',
      cg: 'Congo-Brazzaville',
      ch: 'Suisse',
      ci: 'Côte d’Ivoire',
      ck: 'Îles Cook',
      cl: 'Chili',
      cm: 'Cameroun',
      cn: 'Chine',
      co: 'Colombie',
      cr: 'Costa Rica',
      cu: 'Cuba',
      cv: 'Cap-Vert',
      cw: 'Curaçao',
      cx: 'Île Christmas',
      cy: 'Chypre',
      cz: 'Tchéquie',
      de: 'Allemagne',
      dj: 'Djibouti',
      dk: 'Danemark',
      dm: 'Dominique',
      do: 'République dominicaine',
      dz: 'Algérie',
      ec: 'Équateur',
      ee: 'Estonie',
      eg: 'Égypte',
      eh: 'Sahara occidental',
      er: 'Érythrée',
      es: 'Espagne',
      et: 'Éthiopie',
      fi: 'Finlande',
      fj: 'Fidji',
      fk: 'Îles Malouines',
      fm: 'Micronésie',
      fo: 'Îles Féroé',
      fr: 'France',
      ga: 'Gabon',
      gb: 'Royaume-Uni',
      gd: 'Grenade',
      ge: 'Géorgie',
      gf: 'Guyane française',
      gg: 'Guernesey',
      gh: 'Ghana',
      gi: 'Gibraltar',
      gl: 'Groenland',
      gm: 'Gambie',
      gn: 'Guinée',
      gp: 'Guadeloupe',
      gq: 'Guinée équatoriale',
      gr: 'Grèce',
      gs: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
      gt: 'Guatemala',
      gu: 'Guam',
      gw: 'Guinée-Bissau',
      gy: 'Guyana',
      hk: 'R.A.S. chinoise de Hong Kong',
      hm: 'Îles Heard-et-MacDonald',
      hn: 'Honduras',
      hr: 'Croatie',
      ht: 'Haïti',
      hu: 'Hongrie',
      id: 'Indonésie',
      ie: 'Irlande',
      il: 'Israël',
      im: 'Île de Man',
      in: 'Inde',
      io: 'Territoire britannique de l’océan Indien',
      iq: 'Irak',
      ir: 'Iran',
      is: 'Islande',
      it: 'Italie',
      je: 'Jersey',
      jm: 'Jamaïque',
      jo: 'Jordanie',
      jp: 'Japon',
      ke: 'Kenya',
      kg: 'Kirghizstan',
      kh: 'Cambodge',
      ki: 'Kiribati',
      km: 'Comores',
      kn: 'Saint-Christophe-et-Niévès',
      kp: 'Corée du Nord',
      kr: 'Corée du Sud',
      kw: 'Koweït',
      ky: 'Îles Caïmans',
      kz: 'Kazakhstan',
      la: 'Laos',
      lb: 'Liban',
      lc: 'Sainte-Lucie',
      li: 'Liechtenstein',
      lk: 'Sri Lanka',
      lr: 'Liberia',
      ls: 'Lesotho',
      lt: 'Lituanie',
      lu: 'Luxembourg',
      lv: 'Lettonie',
      ly: 'Libye',
      ma: 'Maroc',
      mc: 'Monaco',
      md: 'Moldavie',
      me: 'Monténégro',
      mf: 'Saint-Martin',
      mg: 'Madagascar',
      mh: 'Îles Marshall',
      mk: 'Macédoine du Nord',
      ml: 'Mali',
      mm: 'Myanmar (Birmanie)',
      mn: 'Mongolie',
      mo: 'R.A.S. chinoise de Macao',
      mp: 'Îles Mariannes du Nord',
      mq: 'Martinique',
      mr: 'Mauritanie',
      ms: 'Montserrat',
      mt: 'Malte',
      mu: 'Maurice',
      mv: 'Maldives',
      mw: 'Malawi',
      mx: 'Mexique',
      my: 'Malaisie',
      mz: 'Mozambique',
      na: 'Namibie',
      nc: 'Nouvelle-Calédonie',
      ne: 'Niger',
      nf: 'Île Norfolk',
      ng: 'Nigeria',
      ni: 'Nicaragua',
      nl: 'Pays-Bas',
      no: 'Norvège',
      np: 'Népal',
      nr: 'Nauru',
      nu: 'Niue',
      nz: 'Nouvelle-Zélande',
      om: 'Oman',
      pa: 'Panama',
      pe: 'Pérou',
      pf: 'Polynésie française',
      pg: 'Papouasie-Nouvelle-Guinée',
      ph: 'Philippines',
      pk: 'Pakistan',
      pl: 'Pologne',
      pm: 'Saint-Pierre-et-Miquelon',
      pn: 'Îles Pitcairn',
      pr: 'Porto Rico',
      ps: 'Territoires palestiniens',
      pt: 'Portugal',
      pw: 'Palaos',
      py: 'Paraguay',
      qa: 'Qatar',
      re: 'La Réunion',
      ro: 'Roumanie',
      rs: 'Serbie',
      ru: 'Russie',
      rw: 'Rwanda',
      sa: 'Arabie saoudite',
      sb: 'Îles Salomon',
      sc: 'Seychelles',
      sd: 'Soudan',
      se: 'Suède',
      sg: 'Singapour',
      sh: 'Sainte-Hélène',
      si: 'Slovénie',
      sj: 'Svalbard et Jan Mayen',
      sk: 'Slovaquie',
      sl: 'Sierra Leone',
      sm: 'Saint-Marin',
      sn: 'Sénégal',
      so: 'Somalie',
      sr: 'Suriname',
      ss: 'Soudan du Sud',
      st: 'Sao Tomé-et-Principe',
      sv: 'Salvador',
      sx: 'Saint-Martin (partie néerlandaise)',
      sy: 'Syrie',
      sz: 'Eswatini',
      tc: 'Îles Turques-et-Caïques',
      td: 'Tchad',
      tf: 'Terres australes françaises',
      tg: 'Togo',
      th: 'Thaïlande',
      tj: 'Tadjikistan',
      tk: 'Tokelau',
      tl: 'Timor oriental',
      tm: 'Turkménistan',
      tn: 'Tunisie',
      to: 'Tonga',
      tr: 'Turquie',
      tt: 'Trinité-et-Tobago',
      tv: 'Tuvalu',
      tw: 'Taïwan',
      tz: 'Tanzanie',
      ua: 'Ukraine',
      ug: 'Ouganda',
      uk: 'Royaume-Uni',
      um: 'Îles mineures éloignées des États-Unis',
      us: 'États-Unis',
      uy: 'Uruguay',
      uz: 'Ouzbékistan',
      va: 'État de la Cité du Vatican',
      vc: 'Saint-Vincent-et-les Grenadines',
      ve: 'Venezuela',
      vg: 'Îles Vierges britanniques',
      vi: 'Îles Vierges des États-Unis',
      vn: 'Viêt Nam',
      vu: 'Vanuatu',
      wf: 'Wallis-et-Futuna',
      ws: 'Samoa',
      xk: 'Kosovo',
      ye: 'Yémen',
      yt: 'Mayotte',
      za: 'Afrique du Sud',
      zm: 'Zambie',
      zw: 'Zimbabwe'
    },
    messages: {
      list: 'Nouvelles',
      new: 'Nouveau message',
      edit: 'modifier le message',
      title: 'titre',
      content: 'Contenu',
      empty: 'Pas de nouvelles',
      direct: 'Message direct',
      toDealers: 'Aux concessionnaires',
      sendEmail: 'Envoyer un e-mail',
      selectWholesalers: 'Sélectionnez un grossiste',
      directWholesaler: 'du grossiste au revendeur',
      selectGroups: 'Sélectionner les groupes',
      directGroup: 'Aux groupes de revendeurs',
      toGroups: 'Aux groupes',
      saveAndSend: 'Enregistrer et envoyer',
      users: "Sélectionnez l'utilisateur (min. 3 caractères)",
      sent: 'Publié',
      externalTrainingPoints: 'Points externes de soutien à la formation/à l’investissement',
      externalTrainingBank: 'Titulaires de comptes externes de formation/soutien à l’investissement',
      externalTrainingIBAN: "Formation externe / accompagnement à l'investissement IBAN",
      onlineTrainingTitle: 'Formation en ligne - Titre',
      onlineTrainingPoints: 'Formation en ligne - points',
      hunterTitle: 'Chasseur - titre',
      hunterPoints: 'Chasseur - Points',
      hunterPrice: 'Chasseur - Prix',
      bTrainingTitle: 'Formation Bridgestone - Titel',
      bTrainingPoints: 'Formation BS - Points',
      pointsProfileComplete: 'Points - profil complété',
      orderProducts: 'Produits dans la commande'
    },
    messages_alert: {
      title: 'Supprimer le message',
      desc: 'Voulez-vous vraiment supprimer le message ?'
    },
    groups_alert: {
      title: 'Supprimer le groupe',
      desc: 'Êtes-vous sûr de vouloir supprimer le groupe ?'
    },
    vendors_alert: {
      title: 'Supprimer le fabricant',
      desc: 'Voulez-vous vraiment supprimer le fabricant ?'
    },
    suppliers_alert: {
      title: 'Supprimer le fournisseur',
      desc: 'Voulez-vous vraiment supprimer le fournisseur ?'
    },
    threads: {
      title: 'Concernant',
      choose: 'Veuillez sélectionner un message',
      order: 'Sélectionnez le sujet des commandes',
      salespromotions: 'Sélectionnez le sujet de la promotion des ventes',
      externalTraining: 'Sélectionner le sujet de la formation externe',
      investment: "Objet du soutien à l'investissement",
      onlineTraining: 'Sujet de formation en ligne',
      hunter: 'Sujet pour Hunter',
      bTraining: 'Sujet de formation Bridgestone',
      profileComplete: 'Sujet de remplissage du profil',
      activeUser: 'Message utilisateur actif'
    },
    userGroup: {
      parentAttributeName: 'Attribut parent',
      name: 'Nom de groupe',
      gka: 'GKA',
      isMain: 'Est parent ?',
      dealersGroupTab: 'Groupe de distributeurs',
      dealersTab: 'Distributeurs',
      searchDealers: 'Rechercher des distributeurs'
    },
    customerGroup: {
      name: 'Nom du groupe de clients'
    },
    role: 'rôle',
    user: 'utilisateur',
    vat: "numéro d'identification fiscale",
    categories: 'Catégories',
    count_users: "nombre d'utilisateurs",
    product: 'produit',
    count_perms: 'Nombre de droits',
    count_products: 'Nombre de produits',
    count_files: 'Nombre de fichiers',
    count_options: "Nombre d'options",
    attribute_new: 'Nouvel attribut',
    category_new: 'Nouvelle catégorie',
    category_title: 'Titre de la catégorie',
    category_desc: 'Description de la catégorie',
    category_image: 'Catégorie Image',
    category_link: 'Lien de catégorie',
    category_alert: {
      title: 'Supprimer la catégorie ',
      desc: 'Voulez-vous vraiment supprimer la catégorie ?'
    },
    text_page_alert: {
      title: 'Supprimer la page de texte',
      desc: 'Voulez-vous vraiment supprimer la page de texte ?'
    },
    news_feed_alert: {
      title: 'Supprimer le fil d’actualités',
      desc: 'Voulez-vous vraiment supprimer le fil d’actualités "{title}" ?'
    },
    newsFeedList: {
      perPage: 'Éléments par page',
      loading: 'Chargement des fils d’actualités…',
      paginationSummary: '{from}–{to} sur {total} (page {page} / {lastPage})',
      moveUp: 'Monter',
      moveDown: 'Descendre'
    },
    ipcList: {
      title: 'Liste IPC',
      perPage: 'Lignes par page',
      clearFilters: 'Effacer les filtres',
      loading: 'Chargement des IPC…',
      accessDenied: 'Vous n’avez pas l’autorisation d’afficher la liste IPC.',
      paginationSummary: '{from}–{to} sur {total}',
      columns: {
        material: 'Matériel / IPC',
        detailed_brand: 'Marque détaillée',
        tyre_size_designation: 'Taille du pneu',
        new_budget_category: 'Catégorie budgétaire',
        service_description: 'Description du service',
        rim: 'Jante',
        marketing_product_brand: 'Marque marketing',
        marketing_product_name: 'Nom produit marketing'
      }
    },
    slider_alert: {
      title: 'Supprimer le slider',
      desc: 'Voulez-vous vraiment supprimer le slider "{title}" ?'
    },
    question_alert: {
      title: 'Delete Question',
      desc: 'Do you really want to delete the question?'
    },
    certificate_alert: {
      title: 'Delete Certificate Text',
      desc: 'Do you really want to delete the certificate text?'
    },
    product_alert: {
      title: 'Supprimer le produit',
      desc: 'Êtes-vous sûr de vouloir supprimer le produit ?'
    },
    cancel: 'Annuler',
    confirm: 'Confirmer',
    options_new: 'Nouvelle option',
    subcategory: 'Sous-catégorie',
    uploadText: 'pour télécharger une photo',
    startImport: "Démarrer l'importation",
    importStarted: "L'importation a commencé",
    connection: 'Connexion',
    variants: 'variantes',
    add_variant: 'Ajouter une variante',
    vendor_new: 'Nouveau fabricant',
    training_edit: 'Modifier la formation',
    vendors: 'Fabricant',
    supplier_new: 'Nouveau fournisseur',
    suppliers: 'Fournisseurs',
    training: 'entraînement',
    commands: {
      ipc: 'Importateur IPC',
      users: 'Importer des utilisateurs',
      boosterImporter: 'Importateur de Booster'
    },
    userImport: {
      label: 'Type XLSX uniquement'
    },
    questions: 'Des questions',
    correctAnswer: 'Bonne réponse',
    validation: {
      required: 'Champ requis'
    },
    edit_question: 'Modifier les questions',
    edit_btraining_Detail: 'Modifier les détails de la formation Bridgestone',
    video_url: 'URL de la vidéo',
    save_new_question: 'Enregistrer une nouvelle question',
    reward: 'Illustration de la prime - non obligatoire',
    poster: "Image de l'affiche",
    sliderImageValidation: "L'image doit faire 1600x1040 px ou 2x/3x/4x cette taille.",
    mainBoxImageValidation: "L'image doit faire 368x150 px ou 2x/3x/4x cette taille.",
    imageDimensions: "Dimensions de l'image",
    season: 'Saison',
    answers: 'Répondre',
    training_details: 'Détails de la formation',
    extras: 'Informations complémentaires',
    duration: 'Une longueur de temps',
    price: 'Prix',
    min_participant: 'Nombre minimum de participants',
    max_participant: 'Nombre maximum de participants',
    choose_trainingType: 'Sélectionnez le type de formation',
    update: 'Mettre à jour',
    cost_type: 'Type de coût',
    save_detail: 'Enregistrer les détails',
    slider_new: 'Nouveau curseur de teaser principal',
    sliders: 'Curseur principal du teaser',
    groups: 'groupes',
    slider: 'Modifier le curseur du teaser principal',
    choose_showHideText: 'Afficher/masquer le texte',
    text_page_new: 'Nouvelle page de texte',
    text_pages: 'Pages de texte',
    text_page: 'Page de texte',
    featured: {
      title: 'Produits teasers',
      bestseller: 'Plus vendu',
      seasonal: 'Saisonnier',
      affordable: 'Presque là',
      autoBestsellers: 'Afficher les best-sellers calculés automatiquement',
      affordableOffsetLabel: 'Compensation de prix maximale',
      affordableLimitLabel: 'Afficher la limite de produits'
    },
    seasons: {
      all: 'Toutes les saisons',
      summer: 'Été',
      winter: 'hiver',
      general: 'En général'
    },
    addAddress: 'Ajouter une adresse',
    administration: 'Administration',
    password: 'mot de passe',
    forcedPasswordChange: {
      title: 'Modifier votre mot de passe',
      description: "Votre mot de passe temporaire doit être modifié avant de pouvoir accéder à l'application.",
      enterNewPassword: 'Saisir le nouveau mot de passe',
      repeatNewPassword: 'Répéter le nouveau mot de passe',
      strengthLabel: 'Force du mot de passe',
      submit: 'Modifier le mot de passe et se connecter',
      generatePassword: 'Générer un mot de passe fort',
      success: 'Le mot de passe a été modifié avec succès',
      loginAfterChangeFailed:
        'Le mot de passe a été modifié, mais la connexion automatique a échoué. Veuillez vous connecter avec votre nouveau mot de passe.',
      sameAsTemporaryPassword: 'Le nouveau mot de passe ne peut pas être identique au mot de passe temporaire.',
      validationError: 'Veuillez corriger les exigences du mot de passe avant de continuer.',
      invalidToken: 'Votre session de changement de mot de passe a expiré. Veuillez vous reconnecter.',
      rules: {
        minLength: 'Au moins 12 caractères',
        uppercase: 'Au moins une lettre majuscule',
        lowercase: 'Au moins une lettre minuscule',
        digit: 'Au moins un chiffre',
        special: 'Caractère spécial recommandé'
      }
    },
    toastMessages: {
      success: "L'opération s'est terminée avec succès",
      error: 'Erreur inattendue, veuillez réessayer plus tard',
      invalid: 'Valeurs invalides dans le formulaire',
      done: 'Complété!',
      requestProcessed: "La demande est en cours de traitement. Un instant s'il vous plaît...",
      noQuestions: 'La formation doit contenir au moins 1 question',
      pointsAdded: 'Réservation effectuée',
      selectUser: 'Sélectionnez un utilisateur dans la liste',
      selectOneField: 'Sélectionnez un champ',
      pointRemoveSoon: 'Les points seront bientôt supprimés',
      dataLoading: 'Les données sont en cours de chargement, veuillez patienter',
      shopStatsStartImportUser: "Démarrage de l'import: Statistiques boutique - UTILISATEUR",
      shopStatsPrepareMissingExportToken: "L'étape Prepare n'a pas renvoyé export_token.",
      shopStatsPrepareInvalidNextChunk: "L'étape Prepare a renvoyé un next_chunk invalide.",
      shopStatsPrepareUnchangedChunkCursor: "L'étape Prepare a renvoyé un chunk/cursor inchangé.",
      shopStatsPrepareMaxIterations: "L'étape Prepare a dépassé le nombre maximal d'itérations.",
      shopStatsConvertInvalidNextSubstep: "L'étape Convert a renvoyé un next_substep invalide.",
      shopStatsConvertMaxIterations: "L'étape Convert a dépassé le nombre maximal d'itérations.",
      shopStatsExportInvalidDownloadUrl: "L'étape Export n'a pas renvoyé une URL de téléchargement valide.",
      shopStatsDone: 'Terminé',
      shopStatsExportFailed: "Échec de l'export"
    },
    stats: {
      users_list: "nombre d'utilisateurs",
      external_trainings_request: 'Formation extérieure',
      product_trainings_request: 'La formation en ligne',
      bridgestone_courses_request: 'Formation Bridgestone',
      hunter_request: 'Chasseur',
      investments_request: "Soutien à l'investissement",
      orders_list: 'Ordres',
      history_list: 'Historique de connexion',
      salespromotions_list: 'Promotion de ventes',
      inactive_users: 'Publier les nouvelles inscriptions',
      complaints_list: 'Formulaire de réclamation',
      points_list: 'Liste des points',
      kickback_list: 'Frais de commission',
      history_hour: "Horaires d'inscription",
      tyre_list: 'Pneus'
    },
    product_trainings_request: 'Demandes de formation en ligne',
    bridgestone_courses_request: 'Demandes de formation Bridgestone',
    attempt_number: "Numéro d'essai",
    thirdPartyInvoice: 'Facture de tiers',
    userInvoice: "Facture de l'utilisateur",
    bankAccountOwner: 'propriétaire du compte',
    open: 'Ouvrir',
    appLogo: "Logo de l'application",
    appURL: "URL de l'application",
    appURLSSOLogin: 'URL après connexion SSO',
    url: 'URL',
    url_text: "Texte de l'URL",
    choose_posterSide: "Page d'images: ",
    left: 'Gauche',
    right: 'Droite',
    disclaimer: 'Clause de non-responsabilité',
    supply: {
      history: 'Historique des approvisionnements',
      quantity: 'Foule'
    },
    copyAsMain: 'Copier comme teaser principal',
    news_feed_slider_list: 'La liste des curseurs du fil d’actualité',
    usersPage: {
      boostersToApprove: 'Booster pour approbation',
      lastLogin: 'Dernière connexion',
      isPreonboarded: 'Pré-embarquement terminé',
      isBl: 'Chef de département',
      customerNumbers: 'Numéro de client',
      branches: 'branches',
      balance: 'solde bancaire',
      orders: 'Ordres',
      groups: 'groupes',
      notes: 'Remarques',
      salesStaff: 'Ventes externes',
      parentBranch: "l'affaire principal",
      childBranch: 'bifurquer',
      addWholesaler: 'Ajouter un grossiste',
      addBranch: 'Ajouter une branche',
      tooltip: 'Pour ajouter une succursale, vous devez enregistrer le numéro de client du magasin principal',
      tooltipRmCnLocal: 'Supprimer le numéro de client local',
      tooltipRmCnDB: 'Supprimer le numéro de client de la base de données',
      statement: 'relevé de compte',
      bank: {
        date: 'Date',
        supplySourceReason: 'Origine/raison',
        customerNumber: 'Kdnr.',
        article: 'Article',
        brand: 'marque',
        product: 'produit',
        type: 'Taper',
        dimension: 'Dimension',
        inch: 'douane',
        season: 'Saison',
        amount: 'Foule',
        otherActions: 'Autre action ou cause',
        totalPoints: 'Points totaux',
        editPoint: 'Modifier les points',
        deleteManualPointConfirm:
          'Êtes-vous sûr de vouloir supprimer cette entrée manuelle de points ({points} points, {date}) ?',
        loadMore: 'Chargez encore 20 chaussons',
        showAll: 'Tout afficher',
        seasons: {
          all: 'Toute la saison',
          summer: 'Avertisseur sonore',
          winter: 'hiver',
          general: 'Générale'
        }
      },
      advanced: 'Avancé',
      deleteUser: "Supprimer l'utilisateur",
      deleteUserConfirm: "Etes-vous sûr de vouloir supprimer l'utilisateur ?",
      deleteUserSuccess: "L'utilisateur a été supprimé.",
      deleteUserNotFound: "L'utilisateur n'existe pas ou a déjà été supprimé.",
      deleteUserDealerConflict:
        'Impossible de supprimer le concessionnaire, car il a des numéros client actifs. Supprimez d’abord les numéros client liés.',
      deleteUserError: "Impossible de supprimer l'utilisateur. Veuillez réessayer.",
      generateTemporaryPassword: 'Générer un mot de passe temporaire',
      generateTemporaryPasswordConfirm:
        'Êtes-vous sûr de vouloir réinitialiser le mot de passe de {user} ? Le mot de passe actuel ne fonctionnera plus.',
      temporaryPasswordGeneratedTitle: 'Mot de passe temporaire généré',
      temporaryPasswordOneTimeWarning: "Ce mot de passe ne s'affiche qu'une seule fois. Copiez-le avant de fermer cette fenêtre.",
      copyPassword: 'Copier dans le presse-papiers',
      passwordCopied: 'Copié',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      generateTemporaryPasswordForbidden: "Vous n'avez pas l'autorisation de générer un mot de passe temporaire.",
      generateTemporaryPasswordNotFound: "L'utilisateur n'existe pas.",
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      deleteCustomerNumber: 'Supprimer le numéro de client',
      manageSalesStaff: 'Gérer le personnel commercial',
      availableSalesStaff: 'Personnel commercial disponible',
      assignedSalesStaff: 'Personnel commercial assigné',
      salesStaffTransferHint:
        'Sélectionnez un ou plusieurs commerciaux à gauche ou à droite. Utilisez les flèches pour les connecter ou les déconnecter de ce concessionnaire.',
      transferSalesStaffRight: 'Connecter le commercial sélectionné',
      transferSalesStaffLeft: 'Déconnecter le commercial sélectionné',
      salesStaffSearchNoResults: 'Aucun commercial correspondant trouvé.',
      addSalesStaff: 'Ajouter un commercial',
      selectSalesStaffToAdd: 'Sélectionner un commercial à ajouter',
      noSalesStaffAssigned: 'Aucun commercial assigné pour le moment.',
      noSalesStaffAvailable: 'Tous les commerciaux disponibles sont déjà assignés.',
      addSalesStaffConfirm: 'Êtes-vous sûr de vouloir ajouter le commercial {salesStaff} à ce concessionnaire ?',
      deleteSalesStaffConfirm: 'Êtes-vous sûr de vouloir supprimer le commercial {salesStaff} de ce concessionnaire ?',
      deleteAddressConfirm: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
      milestones: {
        targetLabel: 'Objectif',
        yearLabel: 'Année',
        new: 'Nouveau',
        empty: 'Aucun objectif pour aucune année. Créez-en un nouveau.',
        editTitle: "Modifier l'objectif",
        createTitle: 'Créer un objectif',
        deleteConfirm: "Êtes-vous sûr de vouloir supprimer le jalon pour l'objectif {target} et l'année {year} ?",
        targetRequiredInfo: "L'objectif est nécessaire pour le calcul correct des points pour l'année sélectionnée."
      },
      milestonesTab: 'Jalons',
      campaignsTab: 'Campagnes',
      dealerGroupsLabel: 'Groupes de revendeurs',
      preOnboardStatusLabel: 'Statut pré-onboard',
      extraEmailsTab: 'E-mails supplémentaires',
      customerGroupsLabel: 'Groupes de clients',
      customerGroupsNone: 'Aucun',
      showDealersList: 'Afficher la liste des revendeurs',
      staffDealersList: 'Liste de vos revendeurs',
      syncSelectedDealers: 'Synchroniser les revendeurs sélectionnés',
      connectAllDealersFromBs: 'Connecter tous les revendeurs de BS+',
      connectAllDealersConfirmTitle: 'Connecter tous les revendeurs',
      connectAllDealersConfirmDescription: 'Voulez-vous vraiment connecter tous les revendeurs à cet utilisateur staff ?',
      disconnectAllDealersConfirmTitle: 'Déconnecter tous les revendeurs',
      disconnectAllDealersConfirmDescription: 'Voulez-vous vraiment déconnecter tous les revendeurs de cet utilisateur staff ?',
      transferDealersToAnotherBsStaff: 'Transférer les revendeurs à un autre collaborateur BS',
      showingCount: 'Affichage {visible} / {total}',
      groupDealersSelectedCount: '{selected} sélectionné(s)',
      groupDealersUnselectedCount: '{unselected} non sélectionné(s)',
      showGroupOnly: 'Afficher uniquement',
      clearGroupFilter: 'Afficher tous les groupes',
      noDealersInSelectedGroups: 'Aucun revendeur dans les groupes sélectionnés',
      downloadConnectedDealers: 'Télécharger les revendeurs connectés',
      showGroupFilters: 'Afficher les filtres de groupe',
      hideGroupFilters: 'Masquer les filtres de groupe',
      staffDealersToolbarSync: 'Synchronisation',
      staffDealersToolbarBulk: 'Actions groupées',
      staffDealersToolbarExport: 'Export',
      importDealersByEmail: 'Importer les revendeurs depuis Excel',
      importDealersByEmailTitle: 'Importer des revendeurs par e-mail',
      importDealersByEmailInfo:
        'Téléversez un fichier Excel (.xlsx, .xls) contenant uniquement des adresses e-mail dans la colonne A.',
      importDealersByEmailHeaderInfo: 'La première ligne peut contenir l\'en-tête "email".',
      importDealersByEmailEmptySheet: 'Le fichier Excel ne contient aucune donnée.',
      importDealersByEmailEmptyColumn: 'La colonne A ne contient aucune adresse e-mail.',
      importDealersByEmailMultipleColumns: "Le fichier ne doit contenir qu'une seule colonne avec des adresses e-mail.",
      importDealersByEmailReadError: 'Impossible de lire le fichier Excel.',
      importDealersByEmailValidating: 'Validation du fichier...',
      importDealersByEmailSummaryTitle: "Résumé de l'import",
      importDealersByEmailAlreadyConnected: 'Déjà connectés',
      importDealersByEmailNewConnections: 'Nouvelles connexions',
      importDealersByEmailNotFound: 'Introuvables dans BS+',
      importDealersByEmailInvalidEmails: "Format d'e-mail invalide",
      importDealersByEmailDuplicates: 'E-mails en double dans le fichier',
      importDealersByEmailSyncButton: 'Connecter et synchroniser',
      importDealersByEmailNoNewConnections: 'Tous les e-mails du fichier sont déjà connectés.',
      importDealersByEmailShowingCount: 'Affichage de {shown} sur {total}',
      notesHelpText: 'Doit contenir 8 à 20 mots.',
      indirectAccessAlert: 'Cet utilisateur a un accès restreint en raison du parcours de type de client INDIRECT.',
      parentAttributesNotEnabled:
        'Vous ne pouvez pas enregistrer les attributs parents pour ce marché. Demandez à un super admin d’activer cette fonction.',
      termsConfirmed: 'Conditions générales confirmées',
      privacyConfirmed: 'Politique de confidentialité confirmée',
      approvedByBs: 'Approuvé par BS+',
      extraDocsConfirmed: 'Documents supplémentaires pour client indirect confirmés',
      restrictedAccess: 'Accès restreint',
      revokeApproval: 'Révoquer l’approbation',
      approve: 'Approuver',
      allowPointsCalculationConfirm:
        'Do you want to activate/deactivate points calculation for customer number {customerNumber} ({wholesaler})?',
      calculateOneCustomerNumberTitle: 'Calculate points for customer number',
      calculateOneCustomerNumberQuestion: 'Would you like to calculate data for customer number {customerNumber}?',
      calculateOneCustomerNumberWholesaler: 'Wholesaler: {wholesaler}',
      calculateOneCustomerNumberYearLabel: 'Year',
      activateCustomerNumberConfirm: 'Are you sure you want to activate customer number {customerNumber} ({wholesaler})?',
      deactivateCustomerNumberConfirm: 'Are you sure you want to deactivate customer number {customerNumber} ({wholesaler})?',
      saveCustomerNumberConfirm:
        'Êtes-vous sûr de vouloir enregistrer ou mettre à jour le numéro de client {customerNumber} ({wholesaler}) ?',
      selectRole: 'Sélectionnez un rôle',
      selectClientType: 'Sélectionnez un type de client',
      selectWholesaler: 'Sélectionnez un grossiste',
      pointsSummary: {
        year: 'Année',
        actions: 'Actions',
        revert: 'Annuler expiration',
        recalculate: 'Recalculer expiration',
        currentPoints: 'Solde de points',
        pointsFromCurrentYear: 'Points de l’année en cours ({year})',
        atRiskLabel: 'Points à dépenser avant le 31.03.{year}',
        loadError: 'Impossible de charger le récapitulatif des points.',
        invalidYear: "L'année doit être un entier entre 2000 et 3000.",
        recalculateConfirm: "Cela supprimera l'ancienne expiration et la recalculera pour l'année {year}. Continuer ?",
        revertSuccess: 'Entrées supprimées : {count}',
        revertConfirm: "Cela supprimera les entrées d'expiration pour l'année {year}. Continuer ?",
        recalculateSuccess: 'Recalcul effectué. Points expirés : {points}',
        recalculateNoop: 'Aucun point à expirer pour cette année.'
      }
    },
    recoverUser: 'Ramener les utilisateurs',
    pieces_per_set: "Unités d'emballage",
    new: 'Nouveau',
    all: 'Tous',
    showAddress: "Afficher l'adresse",
    showGroup: 'Afficher GKA et Bl-Alt',
    showPoints: 'Afficher les scores',
    showKickbacks: 'Afficher les frais de commission',
    external_sales: 'Ventes externes',
    login_from: 'Dernière connexion (à partir de)',
    login_to: "Dernière connexion (jusqu'à)",
    searchUserDownload: {
      title: 'Télécharger les données de recherche',
      description: 'Choisissez le format de fichier pour l’export.',
      formatCsv: 'CSV (.csv)'
    },
    check: 'Vérifier',
    reject: 'Refuser',
    reason: 'Raison',
    active_by: 'Activé par',
    sharePassword: 'Partagez ce mot de passe avec le nouvel administrateur',
    activeBtn: 'Activer maintenant',
    newUserVerify: 'Vérification de la nouvelle inscription',
    complaintForm: {
      sections: {
        general: {
          title: 'en général',
          ordinance: 'Concept de commande du concessionnaire',
          generalEmail: 'Votre adresse e-mail',
          country: 'pays',
          pickupLocation: 'Lieu de ramassage'
        },
        regulator: {
          title: 'adresse du revendeur de pneus - régulateur'
        },
        vehicleDetails: {
          title: 'Informations sur le véhicule',
          vehicleManufacturer: 'Constructeur automobile',
          vehicleModelType: 'Modèle de véhicule et désignation de type selon homologation',
          firstRegistration: 'Inscription initiale',
          enginePower: 'Puissance du moteur (KW par exemple 150)',
          originalEquipment: 'Equipements originels',
          tireMilageHours: 'Kilométrage des pneus (km) / heures de fonctionnement',
          milageOrHours: 'Km ou heures (par exemple 2000)'
        },
        tyre: {
          tireSizeExample: 'Taille des pneus (par exemple 215/60/16)',
          speedLoadIndex: 'Indice de vitesse/charge',
          profileDesignation: 'Désignation du profil avec spécification',
          dot: 'POINT',
          truckSerialNo: 'Numéro de série. (uniquement pour les pneus de camion)',
          complaintReason: 'Motif de la plainte',
          isTyreReplaced: 'Les pneus ont-ils déjà été remplacés ?',
          ifYesTyre: 'Si oui, marque des pneus de remplacement',
          clerkName: 'Nom du greffier',
          complaintReasonText: 'Texte du motif de la réclamation'
        }
      }
    },
    yesText: 'Oui',
    noText: 'Non',
    tyre: 'Pneus',
    maintenance_mode_title: 'Mode maintenance',
    maintenance_mode_description:
      'Voulez-vous vraiment continuer ? Une fois activé, le site sera temporairement indisponible pour les utilisateurs.',
    maintenance_mode_disable_title: 'Désactiver le mode maintenance',
    maintenance_mode_disable_description: 'Voulez-vous vraiment continuer ? Le site redeviendra accessible aux utilisateurs.',
    buttons: {
      close: 'Fermer',
      send: 'Envoyer',
      validateFile: 'Valider le fichier',
      back: 'Retour',
      placeOrder: 'Ordonnance ferme',
      download: 'Télécharger',
      downloadData: 'Télécharger les données',
      downloadSearchResults: 'Télécharger les données de recherche',
      openDownloadModal: 'Afficher la fenêtre de téléchargement des données',
      loading: 'Chargement',
      approve: 'Pour permettre',
      deleteOrder: 'Supprimer la commande',
      archive: 'archive',
      acceptAll: 'Accepter tout',
      advanceSearch: 'Recherche Avancée',
      addMenu: 'Ajouter un menu',
      setMaintenance: "Définir l'entretien",
      hideMaintenance: "Masquer l'entretien",
      deactivate: 'Désactiver',
      importSelected: 'Importer la sélection',
      startOver: 'Recommencer',
      loadMore: 'Charger plus',
      loadAll: 'Tout charger',
      clearFilters: 'Réinitialiser les filtres',
      toSearch: 'Search',
      delete: 'Delete',
      allowAccessToUsers: "Permettre l'accès à un groupe d'utilisateurs"
    },
    others: 'Autre',
    archive_training_title: 'Archiver la formation',
    archive_training: 'Êtes-vous sûr de vouloir archiver cette formation ?',
    delete_menu: "Souhaitez-vous supprimer l'élément de menu ?",
    no_entries: 'Aucune entrée',
    external_url: 'URL externe',
    incomplete_address: "L'adresse est incomplète. Vérifiez s'il vous plaît",
    request_from: 'demande de',
    let_see_points: "Laissez l'utilisateur voir les points marketing",
    let_see_kickback: "Permettre à l'utilisateur de voir les frais de commission occulte",
    major: 'Grep',
    media_category: 'Catégorie "Médias“',
    dragHere: 'Déposez les fichiers ici...',
    dragDropSelectFiles: 'Glissez-déposez des fichiers ici ou cliquez pour sélectionner des fichiers',
    publicFileUploadWarning:
      "Les fichiers téléchargés seront accessibles publiquement. Si des données publiques ou sensibles sont partagées par erreur, l'utilisateur peut rencontrer de graves problèmes. Le téléchargement se fait sous votre propre responsabilité.",
    uploadingFiles: 'Téléchargement des fichiers',
    uploadingCurrentFile: 'Fichier en cours',
    allCategories: 'Toutes les catégories',
    addEmbbeded: 'Ajouter du code intégré',
    canReceivePoints: 'Peut obtenir des points',
    canUsePoints: 'Peut utiliser des points',
    wholesaler_management: {
      modal: {
        description: 'Quelles données le grossiste peut-il voir dans les coordonnées du revendeur ?'
      }
    },
    personalData: 'Données personnelles',
    operatingData: "Données d'exploitation",
    orderDelivery: 'adresse de livraison',
    diffDeliveryAddres: 'ajouter une adresse de livraison',
    current_tyres_amount: 'Montant des pneus',
    current_points: 'Score',
    current_kickbacks: 'Kick-back',
    change_role_info:
      "La modification d'un rôle dans le <b>Bridgestone PLUS-System</b> supprime les connexions associées à un rôle donné, par exemple les points, les numéros de client, les connexions entre un processeur Bridgestone et un revendeur, les commandes, etc. sont supprimés. parce qu'il n'y a pas de retour possible ?",
    firstRegistration: 'Première inscription',
    mediaCategories: {
      products: 'Produits',
      brand_and_solutions: 'Marques & Solutions',
      season_and_promotions: 'Saison & Promotions',
      format: 'Format',
      cars_and_vans: 'Voiture, SUV, Utilitaire',
      truck_and_buses: 'Lkw & Bus',
      motorcycle: 'Motorrad',
      agriculture: 'Landwirtschaft',
      construction_machinery: 'Baumaschinen',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      summer: 'Été',
      winter: 'Hiver',
      all_season: 'Toutes saisons',
      promotions: 'Promotions',
      video: 'Vidéo',
      video_in_store: 'Video (Instore)',
      video_online: 'Video (Online)',
      banner_website: 'Bannière',
      banner_social_media: 'Réseaux sociaux',
      logos: 'Logos',
      b_drive: 'B-drive',
      media_library: 'Media library',
      media_packages: 'Media packages',
      material: 'Matériaux',
      price_list: 'Liste de prix',
      brochures: 'Brochures',
      price: 'Prix'
    },
    fileType: {
      label: 'File type',
      video: 'Video',
      image: 'Image',
      embeded: 'Embeded',
      pdf: 'Pdf'
    },
    deleteMediaModal: {
      title: 'Delete media collection',
      description: "Do you confirm delete file's collection? It will delete all connect files.",
      filesLabel: 'Fichiers qui seront supprimés',
      noFiles: 'Aucun fichier dans cette collection'
    },
    deleteMediaFileModal: {
      title: 'Delete file from collection',
      description: 'Do you want to you delete file from this collection?'
    },
    deleteBrochureFileModal: {
      title: 'Supprimer le fichier de la collection',
      description: 'Voulez-vous supprimer le fichier "{fileName}" de cette collection ?',
      fileNameFallback: 'Fichier inconnu'
    },
    deleteBrochureModal: {
      title: 'Supprimer la brochure',
      description: 'Voulez-vous vraiment supprimer la brochure "{name}" ?',
      nameFallback: 'Brochure inconnue',
      filesLabel: 'Fichiers qui seront supprimés',
      noFiles: 'Aucun fichier dans cette brochure'
    },
    languages: {
      aa: 'afar',
      ab: 'abkhaze',
      ae: 'avestique',
      af: 'afrikaans',
      ak: 'akan',
      am: 'amharique',
      an: 'aragonais',
      ar: 'arabe',
      as: 'assamais',
      av: 'avar',
      ay: 'aymara',
      az: 'azerbaïdjanais',
      ba: 'bachkir',
      be: 'biélorusse',
      bg: 'bulgare',
      bh: 'bhodjpouri',
      bi: 'bichelamar',
      bm: 'bambara',
      bn: 'bengali',
      bo: 'tibétain',
      br: 'breton',
      bs: 'bosniaque',
      ca: 'catalan',
      ce: 'tchétchène',
      ch: 'chamorro',
      co: 'corse',
      cr: 'cree',
      cs: 'tchèque',
      cu: 'slavon d’église',
      cv: 'tchouvache',
      cy: 'gallois',
      da: 'danois',
      de: 'allemand',
      dv: 'maldivien',
      dz: 'dzongkha',
      ee: 'éwé',
      el: 'grec',
      en: 'anglais',
      eo: 'espéranto',
      es: 'espagnol',
      et: 'estonien',
      eu: 'basque',
      fa: 'persan',
      ff: 'peul',
      fi: 'finnois',
      fj: 'fidjien',
      fo: 'féroïen',
      fr: 'français',
      fy: 'frison occidental',
      ga: 'irlandais',
      gd: 'gaélique écossais',
      gl: 'galicien',
      gn: 'guarani',
      gu: 'goudjarati',
      gv: 'mannois',
      ha: 'haoussa',
      he: 'hébreu',
      hi: 'hindi',
      ho: 'hiri motu',
      hr: 'croate',
      ht: 'créole haïtien',
      hu: 'hongrois',
      hy: 'arménien',
      hz: 'héréro',
      ia: 'interlingua',
      id: 'indonésien',
      ie: 'interlingue',
      ig: 'igbo',
      ii: 'yi du Sichuan',
      ik: 'inupiaq',
      io: 'ido',
      is: 'islandais',
      it: 'italien',
      iu: 'inuktitut',
      ja: 'japonais',
      jv: 'javanais',
      ka: 'géorgien',
      kg: 'kikongo',
      ki: 'kikuyu',
      kj: 'kuanyama',
      kk: 'kazakh',
      kl: 'groenlandais',
      km: 'khmer',
      kn: 'kannada',
      ko: 'coréen',
      kr: 'kanouri',
      ks: 'cachemiri',
      ku: 'kurde',
      kv: 'komi',
      kw: 'cornique',
      ky: 'kirghize',
      la: 'latin',
      lb: 'luxembourgeois',
      lg: 'ganda',
      li: 'limbourgeois',
      ln: 'lingala',
      lo: 'lao',
      lt: 'lituanien',
      lu: 'luba-katanga (kiluba)',
      lv: 'letton',
      mg: 'malgache',
      mh: 'marshallais',
      mi: 'maori',
      mk: 'macédonien',
      ml: 'malayalam',
      mn: 'mongol',
      mr: 'marathi',
      ms: 'malais',
      mt: 'maltais',
      my: 'birman',
      na: 'nauruan',
      nb: 'norvégien bokmål',
      nd: 'ndébélé du Nord',
      ne: 'népalais',
      ng: 'ndonga',
      nl: 'néerlandais',
      nn: 'norvégien nynorsk',
      no: 'norvégien',
      nr: 'ndébélé du Sud',
      nv: 'navajo',
      ny: 'chewa',
      oc: 'occitan',
      oj: 'ojibwa',
      om: 'oromo',
      or: 'odia',
      os: 'ossète',
      pa: 'pendjabi',
      pi: 'pali',
      pl: 'polonais',
      ps: 'pachto',
      pt: 'portugais',
      qu: 'quechua',
      rm: 'romanche',
      rn: 'roundi',
      ro: 'roumain',
      ru: 'russe',
      rw: 'kinyarwanda',
      sa: 'sanskrit',
      sc: 'sarde',
      sd: 'sindhi',
      se: 'same du Nord',
      sg: 'sango',
      si: 'cingalais',
      sk: 'slovaque',
      sl: 'slovène',
      sm: 'samoan',
      sn: 'shona',
      so: 'somali',
      sq: 'albanais',
      sr: 'serbe',
      ss: 'swati',
      st: 'sotho du Sud',
      su: 'soundanais',
      sv: 'suédois',
      sw: 'swahili',
      ta: 'tamoul',
      te: 'télougou',
      tg: 'tadjik',
      th: 'thaï',
      ti: 'tigrigna',
      tk: 'turkmène',
      tl: 'filipino',
      tn: 'tswana',
      to: 'tongien',
      tr: 'turc',
      ts: 'tsonga',
      tt: 'tatar',
      tw: 'akan',
      ty: 'tahitien',
      ug: 'ouïghour',
      uk: 'ukrainien',
      ur: 'ourdou',
      uz: 'ouzbek',
      ve: 'venda',
      vi: 'vietnamien',
      vo: 'volapük',
      wa: 'wallon',
      wo: 'wolof',
      xh: 'xhosa',
      yi: 'yiddish',
      yo: 'yoruba',
      za: 'zhuang',
      zh: 'chinois',
      zu: 'zoulou',
      at: 'allemand',
      cz: 'tchèque',
      'fr-FR': 'français',
      'fr-BE': 'français',
      'nl-BE': 'néerlandais'
    },
    colleague: 'collègue',
    tradeInDate: 'data di permuta',
    vouchers: {
      id: 'ID',
      code: 'Code',
      colleagueName: 'Nom du collègue',
      dealerName: 'Nom du revendeur',
      download: 'Télécharger',
      points: 'Nombre de points par bon',
      amount: 'Nombre de bons',
      deleteConfirmTitle: 'Supprimer le bon',
      deleteConfirmDescription: 'Voulez-vous vraiment supprimer ce bon ?'
    },
    selectText: 'Sélectionner',
    brochureCategories: {
      products: 'Produits',
      brand_and_solutions: 'Marque & Solutions',
      season_and_promotions: 'Saison & Promotions',
      format: 'Format',
      cars_and_vans: 'Voitures et utilitaires',
      truck_and_buses: 'Camions et bus',
      motorcycle: 'Motocycle',
      agriculture: 'Agriculture',
      construction_machinery: 'Matériel de construction',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      material: 'Matériaux',
      brochures: 'Brochures',
      price_list: 'Liste de prix',
      materials: 'Matériaux',
      summer: 'Été',
      winter: 'Hiver',
      all_season: 'Toutes saisons',
      trucks: 'Camions',
      technology: 'Technologie',
      oe: 'OE',
      allSeason: 'Toutes saisons',
      season: 'Saison',
      promotions: 'Promotions'
    },
    deleteMainBox: {
      title: 'Supprimer la boîte principale',
      description: 'Etes-vous sûr de vouloir supprimer cet élément?'
    },
    apps: {
      app_new: 'Nouvelle application',
      title: 'Applications',
      name: 'Nom',
      code: 'Code',
      ownerName: 'Nom du propriétaire',
      ownerEmail: 'E-mail du propriétaire',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      chooseFile: 'Choisir un fichier',
      noFileSelected: 'Aucun fichier sélectionné',
      tabDetails: 'Détails',
      tabBusinessUnits: 'Unités commerciales',
      tabLocalizedContent: 'Contenu localisé',
      tabOwners: "Propriétaires d'application",
      isVisibleEveryone: 'Accès ouvert',
      isSSOReady: 'SSO',
      relationDirect: 'Direct',
      relationInDirect: 'Indirect',
      clientType: 'Type de client',
      clientTypeEveryone: 'Tous',
      clientTypeDirect: 'Direct',
      clientTypeIndirect: 'Indirect',
      clientTypeDirectIndirect: 'Direct + Indirect',
      isVisibleEveryoneLabel:
        "Si activé, l'accès est ouvert à tous les utilisateurs correspondant aux paramètres de visibilité ci-dessous. Si désactivé, l'accès est restreint et doit être accordé manuellement par utilisateur dans le profil utilisateur ou via l'import d'une liste d'utilisateurs.",
      isSSOReadyLabel: 'SSO prêt ?',
      relationDirectLabel: 'Clients directs',
      relationInDirectLabel: 'Clients indirects',
      removeOwner: 'Supprimer',
      addNextOwner: 'Ajouter le propriétaire suivant',
      saveOwners: 'Enregistrer les propriétaires',
      local_app: 'Application locale',
      managed_globally_info: "Cette application est gérée par l'administrateur global"
    },
    bsPlus: {
      onboarding: {
        title: "Bienvenue sur Bridgestone <span class='text-danger'>PLUS</span>",
        termsAndConditions: "Conditions générales d'utilisation",
        accept: 'Accepter',
        decline: 'Refuser',
        dataModal:
          'Afin d’adapter cette offre à vos intérêts, nous vous demandons de renseigner brièvement vos intérêts produits ou vos domaines d’activité.',
        scrollToAccept: 'Veuillez faire défiler vers le bas pour accepter nos conditions et continuer',
        welcomeMessage: 'Bienvenue sur Bridgestone Plus',
        tailorOffer:
          'Afin d’adapter cette offre à vos intérêts, nous vous demandons de renseigner brièvement vos intérêts produits ou vos domaines d’activité.',
        bussinessType:
          'Afin d’adapter cette offre à vos intérêts, nous vous demandons de renseigner brièvement vos intérêts produits ou vos domaines d’activité.',
        selectAreas: 'Veuillez sélectionner parmi les domaines suivants',
        multipleAnswers: '(plusieurs réponses possibles):',
        personalPreferences: 'Préférences personnelles',
        carTyres: 'Pneus auto, SUV et utilitaires',
        motorcyclesTyres: 'Pneus moto',
        truckBusTyres: 'Pneus poids lourds et bus',
        agricultureTyres: 'Pneus pour véhicules agricoles',
        otrTyres: 'Pneus OTR',
        save: 'Enregistrer',
        businessRelationship: 'Quelle est votre relation commerciale avec Bridgestone ?',
        selectRelationship: 'Veuillez sélectionner* :',
        tradingPartner: 'Je suis un partenaire commercial qui...',
        tradingPartnerDirect: '... commande directement chez Bridgestone',
        tradingPartnerIndirect: '... commande indirectement (via un grossiste, par ex.)',
        tradingPartnerBoth: '... commande à la fois directement et indirectement',
        fleetResponsibleDirect: 'Je suis responsable de flotte qui...',
        fleetResponsibleIndirect: '... commande indirectement (via le commerce ou le grossiste)',
        fleetResponsibleBoth: '... commande directement et indirectement',
        noBusinessRelationship: "<b>Je n'ai aucune relation commerciale avec Bridgestone</b> (ni directe ni indirecte)",
        yourCustomerNumber: 'Votre numéro client Bridgestone* :',
        enterCustomerNumber: 'Saisissez votre numéro client',
        waitPersonalisedView:
          'Veuillez patienter un instant, votre vue personnalisée de BRIDGESTONE PLUS est en cours de génération.',
        personalised: 'PERSONNALISÉ',
        plusInfo: 'Vous trouverez ici des informations sur votre compte Plus et votre messagerie Plus.',
        continue: 'Continuer',
        skip: 'Ignorer',
        oneOfTwo: '1 sur 2',
        openApps:
          'Vous pouvez ouvrir directement les applications auxquelles vous êtes déjà inscrit. Vous pouvez également demander l’accès à d’autres applications susceptibles de vous intéresser.',
        requiredFields: 'Veuillez renseigner les champs obligatoires : Titre, Prénom, Nom',
        stage: 'Étape',
        chooseOne: '(Veuillez cocher au moins une case)',
        required: '*Champs obligatoires',
        lengthCsNumber: 'Longueur du numéro client : 6 à 10 chiffres',
        waitForAdminApproval:
          'Merci de votre inscription au programme Bridgestone Plus Rewards. Nous examinons actuellement votre demande. Vous recevrez un e-mail de confirmation dès que votre demande sera approuvée.',
        selectTyres: 'DOMAINE D’ACTIVITÉ ET PROFIL'
      }
    },
    anyLogin: 'toute connexion',
    frontend_menu: {
      account: 'Profil',
      plus: 'À propos de Bridgestone Plus',
      salesSupport: 'Support commercial',
      mailbox: 'Boîte mail',
      about: 'À propos de Bridgestone Plus',
      trainingAndCourses: 'Formations en ligne',
      externalTraining: 'Formations externes',
      productInfo: 'Informations produit',
      productBrochures: 'Brochures',
      priceLists: 'Liste de prix',
      price: 'Prix',
      complaintForm: 'Formulaire de réclamation',
      sales_support: 'Support commercial',
      contact_service: 'Contact & Service',
      logOut: 'Déconnexion',
      news: "Fils d'actualité",
      news_feeds: "Fils d'actualité",
      service_number: 'Contact & Service',
      brochure_prices: 'Brochures et liste de prix',
      trainings: 'Formations',
      salesPromotions: 'Promotions des ventes',
      stammdaten: 'Mon profil',
      onlineTrainings: 'Formations en ligne',
      shop: 'Boutique',
      preislisten: 'Liste de prix',
      medias: 'Medias',
      media: 'Médias',
      manageLinks: 'Gérer les liens du menu',
      noModuleLinksAvailable: 'Aucun lien de module disponible pour ce tenant.'
    },
    customerNumbersAssistant: {
      date: {
        title: 'Calculer les points à partir de la date X'
      },
      import: {
        openButton: 'Importer les numéros client',
        loadingModal: 'Chargement du modal...',
        title: 'Importer les numéros client depuis Excel',
        validateButton: 'Valider le fichier',
        submitButton: "Envoyer à l'API",
        submitButtonLoading: 'Envoi en cours...',
        selectWholesalerLabel: 'Grossiste',
        selectGroupLabel: 'Groupe',
        selectWholesalerPlaceholder: 'Sélectionner un grossiste',
        selectGroupPlaceholder: 'Sélectionner un groupe (optionnel)',
        requirementsTitle: 'Exigences du fichier',
        fileFormatRequirement: 'Fichier Excel uniquement: .xlsx ou .xls',
        headerRequirement: 'La ligne d’en-tête doit être: Customer number, Email (colonnes A/B).',
        createdLabel: 'Créés',
        alreadyExistsLabel: 'Déjà existants',
        success: 'Le fichier Excel est valide.',
        previewTitle: 'Aperçu',
        previewCount: '{count} lignes, {pageSize} lignes par page.',
        columnOne: 'Colonne 1',
        columnTwo: 'Colonne 2',
        previousPage: 'Précédent',
        nextPage: 'Suivant',
        pageInfo: 'Page {current} / {total}',
        progressLabel: 'Progression',
        errors: {
          wholesalerRequired: 'Le grossiste est requis.',
          groupRequired: 'Le groupe est requis.',
          fileRequired: 'Le fichier Excel est requis.',
          emptyWorkbook: 'Le classeur Excel est vide.',
          invalidHeaders: 'Le fichier doit contenir exactement 2 colonnes: numéro client et e-mail.',
          emptyRows: 'Le fichier ne contient aucune ligne de données.',
          firstTwoColumnsRequired: 'Ligne {row}: les deux premières colonnes doivent être remplies.',
          invalidCustomerNumber: 'Numéro client invalide à la ligne {row}. Utilisez uniquement des lettres et des chiffres.',
          invalidEmail: 'E-mail invalide à la ligne {row}.',
          invalidFileType: 'Seuls les fichiers Excel (.xlsx, .xls) sont autorisés.',
          readError: 'Impossible de lire le fichier Excel.',
          submitFailed: "Échec de l'envoi des enregistrements à l'API."
        }
      }
    },
    product_sync: {
      syncEnabled: 'Synchronisation activée',
      syncDisabled: 'Synchronisation désactivée',
      syncDisable: 'Mise à jour via API',
      syncEnable: 'Mise à jour manuelle du produit',
      notAvailableDisable: 'Non visible dans la boutique',
      notAvailableEnable: 'Visible dans la boutique',
      notAvailableDisabled: 'Non visible dans la boutique',
      notAvailableEnabled: 'Visible dans la boutique',
      notAvailableError: 'Erreur : non disponible',
      syncError: 'Erreur de synchronisation',
      tooltip: {
        syncEnable:
          'Veuillez noter que la mise à jour manuelle du produit est limitée à la gestion des prix et des points. Toutes les autres informations relatives au produit seront mises à jour via l’API et ne peuvent pas être modifiées par l’administrateur local.',
        notAvailableEnable: 'Marquer le produit comme non disponible pour ce marché.',
        notAvailableDisable: 'Rendre le produit à nouveau disponible pour ce marché.'
      }
    },
    category_sync: {
      syncEnabled: 'Synchronisation de l’image activée',
      syncDisabled: 'Synchronisation de l’image désactivée',
      syncDisable: 'Mettre à jour l’image via API',
      syncEnable: 'Mise à jour manuelle de l’image',
      syncError: 'Erreur de synchronisation de l’image',
      tooltip: {
        syncEnable:
          'La désactivation de la synchronisation concerne uniquement l’image de la catégorie. Le nom, la description et le statut proviennent toujours du catalogue global. Tant que la synchronisation de l’image est activée, l’image est prise dans le catalogue global et ne peut pas être modifiée localement.'
      }
    },
    priceCategories: {
      pkw: 'Pkw, 4x4 et utilitaires',
      motorcycles: 'Motos',
      trucksAndBuses: 'Camions et bus',
      agriculture: 'Agriculture',
      constructionMachineryOtr: 'Engins de chantier OTR'
    },
    campaigns: {
      title: 'Campagnes',
      new: 'Nouvelle campagne',
      edit: 'Modifier la campagne',
      name: 'Nom de la campagne',
      subtitle: 'Sous-titre de la campagne (optionnel)',
      description: 'Description',
      type: 'Type de campagne',
      selectType: 'Sélectionner le type de campagne',
      periodName: 'Nom de la période',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      newPeriod: 'Nouvelle période',
      image: 'Image',
      url: 'URL',
      active: 'Actif',
      types: {
        'performance-speedy': 'Performance',
        'performance-cd': 'Performance CD',
        'booster-ccs': 'Booster CCS'
      },
      transferDealersModal: {
        openButton: 'Transférer les revendeurs vers une autre campagne',
        title: 'Sélectionner une campagne',
        description: 'Vous pouvez transférer les revendeurs de la campagne actuelle {campaignName} vers une autre.',
        loadingCampaigns: 'Chargement des campagnes...',
        selectCampaignPlaceholder: 'Sélectionner une campagne',
        submit: 'Envoyer la demande',
        sending: 'Envoi en cours...',
        requestSent: 'Demande envoyée',
        requestFailed: "Échec de l'envoi de la demande"
      },
      alert: {
        title: 'Confirmer',
        desc: 'Voulez-vous vraiment supprimer cette campagne ?'
      }
    }
  },
  wholesaler_management: {
    modal: {
      description: 'Quelles données le grossiste peut-il voir dans les coordonnées du revendeur ?'
    }
  },
  marketingConsents: {
    pageTitle: 'Consentements marketing',
    title: 'Titre',
    status: 'Statut',
    noConsents: 'Aucun consentement marketing disponible',
    enabled: 'Activé',
    disabled: 'Désactivé',
    enable: 'Activer',
    disable: 'Désactiver',
    enableTitle: 'Activer le consentement marketing',
    enableMessage: 'Êtes-vous sûr de vouloir activer ce consentement marketing ?',
    disableTitle: 'Désactiver le consentement marketing',
    disableMessage: 'Êtes-vous sûr de vouloir désactiver ce consentement marketing ?',
    toggleSuccess: 'Le statut du consentement marketing a été mis à jour avec succès',
    toggleError: "Une erreur s'est produite lors de la mise à jour du consentement marketing",
    consentType: 'Type de consentement',
    selectType: 'Sélectionner le type...',
    typeChanged: 'Type de consentement mis à jour avec succès',
    typeChangeError: 'Échec de la mise à jour du type de consentement',
    visibleFrom: 'Visible à partir du',
    notYetVisible: 'Pas encore visible',
    alwaysVisible: 'Toujours visible'
  }
}
